import { format } from "date-fns";
import { it } from 'date-fns/locale/it';
import { registerLocale } from "react-datepicker";
import { BusinessRegisterRequestReason, BusinessRegisterRequestType } from "../pages/gestioneClienti/registriAziendali/dataService/dto";
import { ConformityEnum } from "../pages/gestioneControllo/m024/dataService/dto";
import { PACVisitingModeEnum, PACVisitingTypeEnum } from "../pages/gestioneControllo/pac/dataService/dto";
import { ConversionPeriodState } from "../pages/gestioneControllo/periodoConversione/dataService/dto";
import { ReportingInnerState, ReportingOuterState, ReportingType } from "../pages/gestioneControllo/segnalazioni/dataService/dto";
import { CodexSampleChangeStatusEnum } from "../pages/gestionePrelievi/dataService/dto";
import { ReinforcedMotivationsEnum } from "../pages/gestioneProvvedimenti/reinforcedControlMeasure/dataService/dto";
import { AssignmentStateEnum, InspectionVisitControlResultEnum, InspectionVisitModeEnum, InspectionVisitNonComplianceTypeEnum, InspectionVisitTypeEnum, IVActivityEnum, IVActivityTypeEnum, IVAuditedActivityEnum, ResultControlComplianceEnum } from "../pages/incarichi/dataservice/dto";
import { EvaluationResultEnum, TestReportResultEnum } from "../pages/incarichi/inspectionVisit/edit/gestionePrelievi/dataservice/dto";
import { CarTypeEnum, PaymentTypeEnum, ProformaStatusEnum, ReimbursementTypeEnum, UsedVehicleEnum } from "../pages/incarichi/inspectionVisit/edit/gestioneRimborsi/dataservice/dto";
import { NotTypeEnum } from "../pages/monitoraggi/monitoraggioNotifiche/dataService/dto";
import { ValTypeEnum } from "../pages/monitoraggi/monitoringValutazioni/dataService/dto";
import { filierraNotContoTerzi, ProcessingActivityEnum, ProcessingMethodType } from "../pages/notifiche/biologica/contoTerzi/dataService/dto";
import { MethodEnum } from "../pages/notifiche/biologica/particelle/dataservice/dto";
import { ExpirationTypeEnum } from "../pages/notifiche/biologica/stato/dataservice/dto";
import { NotificationTypeEnum, NotificationVariation, ReleaseStatusEnum } from "../pages/notifiche/dataservice/dto";
import { GGNotificationTypeEnum, GGStandardEnum, StandardOptionEnum, StandardSubfieldEnum, ValutationResultEnum } from "../pages/notifiche/globalGap/dataservice/dto";
import { CropTypeEnum, GGManipulationEnum, HarvestingTypeEnum } from "../pages/notifiche/globalGap/opzione1/dataservice/dto";
import { NotProdIntegrataEnum, NotProdIntegrataScopoEnum } from "../pages/notifiche/prodIntegrata/dataService/dto";
import { ServiceTypeNormEnum, ServiceTypeUnitEnum } from "../pages/schedaCalcolo/dataService/dto";
export type PromiseStatuses = 'idle' | 'loading' | 'successfully' | 'failed'
export type OnButtonClick = React.MouseEventHandler<HTMLButtonElement> | undefined
export type OnMenuItemClick = React.MouseEventHandler<HTMLLIElement> | undefined
export type OnChange = React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
export type OnFocus = React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
export type OnKeyDown = React.KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
export type Operation = 'save' | 'edit'
export const BACKEND_HOST = 'http://localhost:8080'
export type QuarkusError = { message: string }[]

registerLocale('it', it)

export function truncate(str: string) {
    return str.length > 20 ? str.substring(0, 17) + "..." : str;
}

export async function toBase64(file: File): Promise<string> {
    const bytes = new Uint8Array(await file.arrayBuffer());

    let binary = '';

    for (let i = 0; i < bytes.byteLength; i++) {

        binary += String.fromCharCode(bytes[i]);

    }
    return btoa(binary);
}

export const breadcrumbsLabel = new Map<string, string>([
    ['dashboard', 'Dashboard'],
    ['users', 'Utenti'],
])

export const formatterDate = (date: string | Date | undefined): string => {
    return date ? format(new Date(date), 'dd/MM/yyyy', { locale: it }) : '';
};

export function getNotificationLabelByValue(value: string): string {
    const option = NotificationTypeOptions.find(opt => opt.value === value)
    return option ? option.label : "Nessuna etichetta trovata"
}

export const optionsFormatter = (str: string, options: OptionType[]) => {
    return options.find(o => o.value === str)?.label
}

export function findClosestDate(dates: Date[], today: Date): Date {
    return dates.reduce((closest, currentDate) => {
        const diffClosest = Math.abs(today.getTime() - closest.getTime());
        const diffCurrent = Math.abs(today.getTime() - currentDate.getTime());

        return diffCurrent < diffClosest ? currentDate : closest;
    });
}

export function formatDecimalTime(decimalTime: number): string {
    const hours = Math.floor(decimalTime);
    const minutes = Math.round((decimalTime - hours) * 60);

    return `${hours}h ${minutes}m`;
}

export type OptionType = {
    value: string;
    label: string;
};

export const attivita_bio = [
    { value: 'A', label: 'Produzione' },
    { value: 'B', label: 'Preparazione' },
    { value: 'C', label: 'Distribuzione/Immissione sul mercato' },
    { value: 'D', label: 'Magazzinaggio' },
    { value: 'E', label: 'Importazione' },
    { value: 'F', label: 'Esportazione' }
]

export const getLabelACtivity = (value: string, map: string) => {
    if (map === 'attivita_bio') {
        const activity = attivita_bio.find(activity => activity.value === value);
        return activity ? activity.label : undefined;
    }
    else if (map === 'categorie_prodotti') {
        const category = categorie_prodotti.find(category => category.value === value);
        return category ? category.label : undefined;
    }
    return undefined
};

export const categorie_prodotti = [
    { value: 'A', label: 'Vegetali e prodotti vegetali non trasformati, compresi sementi e altro materiale riproduttivo vegetale' },
    { value: 'B', label: 'Animali e prodotti animali non trasformati' },
    { value: 'C', label: 'Alghe e prodotti di acquacoltura non trasformati' },
    { value: 'D', label: 'Prodotti agricoli trasformati, inclusi prodotti di acquacoltura, destinati ad essere utilizzati come alimenti' },
    { value: 'E', label: 'Mangimi' },
    { value: 'F', label: 'Vino' },
    { value: 'G', label: 'Altri prodotti elencati nell’allegato I del presente regolamento o non ricompresi nelle precedenti categorie' },
]

export const categorie_prodotti_A = [
    { value: 'A', label: 'Vegetali e prodotti vegetali non trasformati, compresi sementi e altro materiale riproduttivo vegetale' },
    { value: 'B', label: 'Animali e prodotti animali non trasformati' },
    { value: 'C', label: 'Alghe e prodotti di acquacoltura non trasformati' },
    { value: 'G', label: 'Altri prodotti elencati nell’allegato I del presente regolamento o non ricompresi nelle precedenti categorie' },
]

export const prodotti = [
    { value: 'A', label: 'Lieviti utilizzati come alimenti o come mangimi ' },
    { value: 'B', label: 'Mate, granturco dolce, foglie di vite, cuori di palma, germogli di luppolo e altre parti commestibili simili di vegetali e prodotti da esse ottenuti' },
    { value: 'C', label: 'Sale marino e altri sali per alimenti e mangimi' },
    { value: 'D', label: 'Bozzoli di bachi da seta atti alla trattura' },
    { value: 'E', label: 'Gomme e resine naturali' },
    { value: 'F', label: 'Cera d’api' },
    { value: 'G', label: 'Oli essenziali' },
    { value: 'H', label: 'Turaccioli di sughero naturale, non agglomerati, e senza leganti' },
    { value: 'I', label: 'Cotone, non cardato né pettinato' },
    { value: 'M', label: 'Lana, non cardata né pettinata' },
    { value: 'L', label: 'Pelli gregge e non trattate' },
    { value: 'N', label: 'Preparati erboristici tradizionali a base vegetale' },
]


export interface RowActivityMultiSelect {
    bioActivity?: string;
    bioCategories?: { label: string; value: string }[];
    ggStandard?: string,
    ggIfaOption?: string
    startingActivity: string;
    endingActivity: string;
}

export const role = [
    { value: 'Amm', label: 'Amm' },
    { value: 'admin', label: 'Admin' },
    { value: 'DG', label: 'DG' },
    { value: 'RSCo', label: 'RSCo' },
    { value: 'FUCO', label: 'FUCO' },
    { value: 'RSCe', label: 'RSCe' },
    { value: 'FUCE', label: 'FUCE' },
    { value: 'RST', label: 'RST' },
    { value: 'FST', label: 'FST' },
    { value: 'UCA', label: 'UCA' },
    { value: 'VAL', label: 'VAL' },
    { value: 'OCD', label: 'OCD' },
    { value: 'CSI', label: 'CSI' },
    { value: 'SM', label: 'SM' },
    { value: 'CSM', label: 'CSM' },
    { value: 'RD', label: 'RD' },
    { value: 'RSOT', label: 'RSOT' },
    { value: 'CSOT', label: 'CSOT' },
    { value: 'PISP', label: 'PISP' },
    { value: 'OP', label: 'OP' },

]

export const regioniProvinceMap: Map<string, string[]> = new Map([
    ["Abruzzo", ["Chieti", "L'Aquila", "Pescara", "Teramo"]],
    ["Basilicata", ["Matera", "Potenza"]],
    ["Calabria", ["Catanzaro", "Cosenza", "Crotone", "Reggio Calabria", "Vibo Valentia"]],
    ["Campania", ["Avellino", "Benevento", "Caserta", "Napoli", "Salerno"]],
    ["Emilia Romagna", ["Bologna", "Ferrara", "Forlì-Cesena", "Modena", "Parma", "Piacenza", "Ravenna", "Reggio Emilia", "Rimini"]],
    ["Friuli Venezia Giulia", ["Gorizia", "Pordenone", "Trieste", "Udine"]],
    ["Lazio", ["Frosinone", "Latina", "Rieti", "Roma", "Viterbo"]],
    ["Liguria", ["Genova", "Imperia", "La Spezia", "Savona"]],
    ["Lombardia", ["Bergamo", "Brescia", "Como", "Cremona", "Lecco", "Lodi", "Mantova", "Milano", "Monza e della Brianza", "Pavia", "Sondrio", "Varese"]],
    ["Marche", ["Ancona", "Ascoli Piceno", "Fermo", "Macerata", "Pesaro e Urbino"]],
    ["Molise", ["Campobasso", "Isernia"]],
    ["Piemonte", ["Alessandria", "Asti", "Biella", "Cuneo", "Novara", "Torino", "Verbano-Cusio-Ossola", "Vercelli"]],
    ["Puglia", ["Bari", "Barletta-Andria-Trani", "Brindisi", "Foggia", "Lecce", "Taranto"]],
    ["Sardegna", ["Cagliari", "Nuoro", "Oristano", "Sassari", "Sud Sardegna"]],
    ["Sicilia", ["Agrigento", "Caltanissetta", "Catania", "Enna", "Messina", "Palermo", "Ragusa", "Siracusa", "Trapani"]],
    ["Toscana", ["Arezzo", "Firenze", "Grosseto", "Livorno", "Lucca", "Massa-Carrara", "Pisa", "Pistoia", "Prato", "Siena"]],
    ["Trentino-Alto Adige", ["Bolzano", "Trento"]],
    ["Umbria", ["Perugia", "Terni"]],
    ["Valle d'Aosta", ["Aosta"]],
    ["Veneto", ["Belluno", "Padova", "Rovigo", "Treviso", "Venezia", "Verona", "Vicenza"]]
]);

export interface Province {
    name: string;
    code: string;
}

export interface Region {
    name: string;
    provinces: Province[];
}

export enum CustomOptions {
    YES = 'YES',
    NO = 'NO',
}

export enum ContractType {
    STANDARD = 'STANDARD',
    C08 = 'C08',
}

export enum CustomFormazioneOptions {
    WEBINAR = 'WEBINAR',
    IN_SEDE = 'IN_SEDE',
}

export const regions = [
    {
        name: "Abruzzo",
        provinces: [
            { name: "L'Aquila", code: "AQ" },
            { name: "Teramo", code: "TE" },
            { name: "Pescara", code: "PE" },
            { name: "Chieti", code: "CH" }
        ]
    },
    {
        name: "Basilicata",
        provinces: [
            { name: "Potenza", code: "PZ" },
            { name: "Matera", code: "MT" }
        ]
    },
    {
        name: "Calabria",
        provinces: [
            { name: "Catanzaro", code: "CZ" },
            { name: "Cosenza", code: "CS" },
            { name: "Crotone", code: "KR" },
            { name: "Reggio Calabria", code: "RC" },
            { name: "Vibo Valentia", code: "VV" }
        ]
    },
    {
        name: "Campania",
        provinces: [
            { name: "Avellino", code: "AV" },
            { name: "Benevento", code: "BN" },
            { name: "Caserta", code: "CE" },
            { name: "Napoli", code: "NA" },
            { name: "Salerno", code: "SA" }
        ]
    },
    {
        name: "Emilia Romagna",
        provinces: [
            { name: "Bologna", code: "BO" },
            { name: "Ferrara", code: "FE" },
            { name: "Forlì-Cesena", code: "FC" },
            { name: "Modena", code: "MO" },
            { name: "Parma", code: "PR" },
            { name: "Piacenza", code: "PC" },
            { name: "Ravenna", code: "RA" },
            { name: "Reggio Emilia", code: "RE" },
            { name: "Rimini", code: "RN" }
        ]
    },
    {
        name: "Friuli-Venezia Giulia",
        provinces: [
            { name: "Gorizia", code: "GO" },
            { name: "Pordenone", code: "PN" },
            { name: "Trieste", code: "TS" },
            { name: "Udine", code: "UD" }
        ]
    },
    {
        name: "Lazio",
        provinces: [
            { name: "Frosinone", code: "FR" },
            { name: "Latina", code: "LT" },
            { name: "Rieti", code: "RI" },
            { name: "Roma", code: "RM" },
            { name: "Viterbo", code: "VT" }
        ]
    },
    {
        name: "Liguria",
        provinces: [
            { name: "Genova", code: "GE" },
            { name: "Imperia", code: "IM" },
            { name: "La Spezia", code: "SP" },
            { name: "Savona", code: "SV" }
        ]
    },
    {
        name: "Lombardia",
        provinces: [
            { name: "Bergamo", code: "BG" },
            { name: "Brescia", code: "BS" },
            { name: "Como", code: "CO" },
            { name: "Cremona", code: "CR" },
            { name: "Lecco", code: "LC" },
            { name: "Lodi", code: "LO" },
            { name: "Mantova", code: "MN" },
            { name: "Milano", code: "MI" },
            { name: "Monza e Brianza", code: "MB" },
            { name: "Pavia", code: "PV" },
            { name: "Sondrio", code: "SO" },
            { name: "Varese", code: "VA" }
        ]
    },
    {
        name: "Marche",
        provinces: [
            { name: "Ancona", code: "AN" },
            { name: "Ascoli Piceno", code: "AP" },
            { name: "Fermo", code: "FM" },
            { name: "Macerata", code: "MC" },
            { name: "Pesaro e Urbino", code: "PU" }
        ]
    },
    {
        name: "Molise",
        provinces: [
            { name: "Campobasso", code: "CB" },
            { name: "Isernia", code: "IS" }
        ]
    },
    {
        name: "Piemonte",
        provinces: [
            { name: "Alessandria", code: "AL" },
            { name: "Asti", code: "AT" },
            { name: "Biella", code: "BI" },
            { name: "Cuneo", code: "CN" },
            { name: "Novara", code: "NO" },
            { name: "Torino", code: "TO" },
            { name: "Verbano-Cusio-Ossola", code: "VB" },
            { name: "Vercelli", code: "VC" }
        ]
    },
    {
        name: "Puglia",
        provinces: [
            { name: "Bari", code: "BA" },
            { name: "Barletta-Andria-Trani", code: "BT" },
            { name: "Brindisi", code: "BR" },
            { name: "Foggia", code: "FG" },
            { name: "Lecce", code: "LE" },
            { name: "Taranto", code: "TA" }
        ]
    },
    {
        name: "Sardegna",
        provinces: [
            { name: "Cagliari", code: "CA" },
            { name: "Nuoro", code: "NU" },
            { name: "Oristano", code: "OR" },
            { name: "Sassari", code: "SS" },
            { name: "Sud Sardegna", code: "SU" }
        ]
    },
    {
        name: "Sicilia",
        provinces: [
            { name: "Agrigento", code: "AG" },
            { name: "Caltanissetta", code: "CL" },
            { name: "Catania", code: "CT" },
            { name: "Enna", code: "EN" },
            { name: "Messina", code: "ME" },
            { name: "Palermo", code: "PA" },
            { name: "Ragusa", code: "RG" },
            { name: "Siracusa", code: "SR" },
            { name: "Trapani", code: "TP" }
        ]
    },
    {
        name: "Toscana",
        provinces: [
            { name: "Arezzo", code: "AR" },
            { name: "Firenze", code: "FI" },
            { name: "Grosseto", code: "GR" },
            { name: "Livorno", code: "LI" },
            { name: "Lucca", code: "LU" },
            { name: "Massa-Carrara", code: "MS" },
            { name: "Pisa", code: "PI" },
            { name: "Pistoia", code: "PT" },
            { name: "Prato", code: "PO" },
            { name: "Siena", code: "SI" }
        ]
    },
    {
        name: "Trentino-Alto Adige",
        provinces: [
            { name: "Bolzano", code: "BZ" },
            { name: "Trento", code: "TN" }
        ]
    },
    {
        name: "Umbria",
        provinces: [
            { name: "Perugia", code: "PG" },
            { name: "Terni", code: "TR" }
        ]
    },
    {
        name: "Valle d'Aosta",
        provinces: [
            { name: "Aosta", code: "AO" }
        ]
    },
    {
        name: "Veneto",
        provinces: [
            { name: "Belluno", code: "BL" },
            { name: "Padova", code: "PD" },
            { name: "Rovigo", code: "RO" },
            { name: "Treviso", code: "TV" },
            { name: "Venezia", code: "VE" },
            { name: "Verona", code: "VR" },
            { name: "Vicenza", code: "VI" }
        ]
    }
];

export const regioniListOperativeAreas = [
    { label: "Abruzzo", value: "ABRUZZO" },
    { label: "Basilicata", value: "BASILICATA" },
    { label: "Calabria", value: "CALABRIA" },
    { label: "Campania", value: "CAMPANIA" },
    { label: "Emilia Romagna", value: "EMILIA_ROMAGNA" },
    { label: "Friuli Venezia Giulia", value: "FRIULI_VENEZIA_GIULIA" },
    { label: "Lazio", value: "LAZIO" },
    { label: "Liguria", value: "LIGURIA" },
    { label: "Lombardia", value: "LOMBARDIA" },
    { label: "Marche", value: "MARCHE" },
    { label: "Molise", value: "MOLISE" },
    { label: "Piemonte", value: "PIEMONTE" },
    { label: "Puglia", value: "PUGLIA" },
    { label: "Sardegna", value: "SARDEGNA" },
    { label: "Sicilia", value: "SICILIA" },
    { label: "Toscana", value: "TOSCANA" },
    { label: "Trentino-Alto Adige", value: "TRENTINO_ALTO_ADIGE" },
    { label: "Umbria", value: "UMBRIA" },
    { label: "Valle d'Aosta", value: "VALLE_D_AOSTA" },
    { label: "Veneto", value: "VENETO" }
];

export const regioniList = [
    { label: "Non Definita", value: "ND" },
    { label: "Abruzzo", value: "Abruzzo" },
    { label: "Basilicata", value: "Basilicata" },
    { label: "Calabria", value: "Calabria" },
    { label: "Campania", value: "Campania" },
    { label: "Emilia Romagna", value: "Emilia Romagna" },
    { label: "Friuli Venezia Giulia", value: "Friuli Venezia Giulia" },
    { label: "Lazio", value: "Lazio" },
    { label: "Liguria", value: "Liguira" },
    { label: "Lombardia", value: "Lombardia" },
    { label: "Marche", value: "Marche" },
    { label: "Molise", value: "Molise" },
    { label: "Piemonte", value: "Piemonte" },
    { label: "Puglia", value: "Puglia" },
    { label: "Sardegna", value: "Sardegna" },
    { label: "Sicilia", value: "Sicilia" },
    { label: "Toscana", value: "Toscana" },
    { label: "Trentino-Alto Adige", value: "Trentino Alto Adige" },
    { label: "Umbria", value: "UMBRIA" },
    { label: "Valle d'Aosta", value: "Valle d'Aosta" },
    { label: "Veneto", value: "Veneto" }
];

export const sot = [
    { value: 'SC', label: 'Sede Centrale' },
    { value: 'CL', label: 'SOT Calabria' },
    { value: 'IS', label: 'SOT Italia Settentrionale' },
    { value: 'PU', label: 'SOT Puglia' },
    { value: 'BA', label: 'SOT Basilicata' },
    { value: 'IM', label: 'SOT Italia Meridionale' },
    { value: 'TV', label: 'SOT Triveneto' }
]

export const status = [
    { value: 'active', label: 'Attivo' },
    { value: 'inactive', label: 'Non Attivo' },
]

export const genreSelect = [
    { value: 'M', label: 'Maschio' },
    { value: 'F', label: 'Femmina' },
]

export const normativa = [
    { value: 'NORMA_BIO', label: 'Biologico' },
    { value: 'PRODUZIONE_INTEGRATA', label: 'Produzione Integrata' },
    { value: 'DETERGENZA', label: 'Detergenza' },
    { value: 'GLOBAL_GAP', label: 'GlobalGAP' },
    { value: 'QUALITA_SICURA', label: 'Qualità Sicura' },
    { value: 'RESIDUO_ZERO', label: 'Residuo Zero' },
]

export const normativaView = [
    { value: 'NORMA_BIO', label: 'Bio' },
    { value: 'PRODUZIONE_INTEGRATA', label: 'SQNPI' },
    { value: 'DETERGENZA', label: 'Detergenza' },
    { value: 'GLOBAL_GAP', label: 'GlobalG.A.P.' },
    { value: 'QUALITA_SICURA', label: 'QS' },
    { value: 'RESIDUO_ZERO', label: 'RZ' },
]

export const normativaCategories: OptionType[] = [
    { value: 'AB', label: 'Agricoltura Biologica' },
    { value: 'GAP', label: 'GLOBALG.A.P.' },
    { value: 'SQNPI', label: 'SQNPI' },
    { value: 'Gen', label: 'Generica' },
]

export const formaGiuridica = [
    { value: 'NON_DEFINITO', label: 'Non Definito' },
    { value: 'DITTA_INDIVIDUALE', label: 'Ditta Individuale' },
    { value: 'SOCIETA', label: 'Società' },
    { value: 'COOPERATIVA', label: 'Cooperativa' },
    { value: 'ASSOCIAZIONE', label: 'Associazione' },
    { value: 'SOCIETA_COOPERATIVA', label: 'Società Cooperativa' },
]

export const mapRole = [
    { role: 'Amm', label: 'Amministrazione', sigla: 'Amm', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'DG', label: 'Direzione', sigla: 'DG', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'RSCo', label: 'Responsabile Ufficio Controllo', sigla: 'RSCo', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'FUCO', label: 'Funzionari Ufficio Controllo', sigla: 'FUCO', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'RSCe', label: 'Responsabile Ufficio Certificazione', sigla: 'RSCe', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'FUCE', label: 'Funzionari Ufficio Certificazione', sigla: 'FUCE', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'RST', label: 'Responsabile Ufficio Segreteria Tecnica', sigla: 'RST', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'FST', label: 'Funzionari Ufficio Segreteria Tecnica', sigla: 'FST', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'UCA', label: 'Funzionari Amministrazione', sigla: 'UCA', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'VAL', label: 'Valutatore processo di Controllo', sigla: 'VAL', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'SM', label: 'Scheme Manager', sigla: 'SM', normativa: 'GlobalGap', regioni: 'Tutte' },
    { role: 'OCD', label: 'Organo Collegiale di Delibera)', sigla: 'OCD', normativa: 'Tutte', regioni: 'Tutte' },
    { role: 'OP', label: 'Operatore', sigla: 'OP', normativa: 'Tutte', regioni: 'Tutte' },
]

export const residuo_zero_type = [
    { value: 'RESIDUO_ZERO', label: 'Residuo zero' },
    { value: 'RESIDUO_CONTROLLATO', label: 'Residuo controllato' }
]

export const tipoSoggetto = [
    { value: 'SINGOLO', label: 'Singolo' },
    { value: 'ASSOCIATO', label: 'Associato' },
]

export const requisiti_certificazione = [
    { value: 'PACKAGING_COMPOSTABILE', label: 'Packaging compostabile' },
    { value: 'PACKAGING_PLASTIC_FREE', label: 'packaging “plastic free”' },
    { value: 'NON_UTILIZZA_PRINCIPI_ATTIVI', label: 'Non Utilizza principio/i attivo/i' }
]

export const tipologia_residuo_zero = [
    { value: 'PRODUTTORE_AGRICOLO', label: 'Produttore Agricolo' },
    { value: 'IMPRESA_DI_TRASFORMAZIONE_CONDIZIONAMENTO_STOCCAGGIO_COMMERCIALIZZAZIONE_ECC', label: 'Impresa di Trasformazione, Condizionamento, Stoccaggio, Commercializzazione, ecc.' },
    { value: 'PRODUTTORE_AGRICOLO_ED_IMPRESA_DI_TRASFORMAIONE_CONDIZIONAMENTO_STOCCAGGIO_COMMERCIALIZZAIZONE_ECC', label: 'Produttore Agricolo ed Impresa di Trasformazione, Condizionamento, Stoccaggio, Commercializzazione, ecc.' }
]

/*
** GLOBAL GAP
*/

export const global_standards = [
    { value: 'IFA', label: 'IFA (Integrated Farm Assurance)' },
    { value: 'CoC', label: 'CoC Catena di Custodia (Chain of Custody)' }
]

export const global_standards_options_functions = [
    { label: 'Opzione1', value: 'OPZIONE_1' },
    { label: 'Opzione2', value: 'OPZIONE_2' }
]

export const edizioni = [
    { value: 'SMART', label: 'SMART' },
    { value: 'GFS', label: 'GFS' }
]

export const campo_di_applicazione = [
    { value: 'PIANTE', label: 'Piante' },
    { value: 'AQUACULTURE', label: 'Aquaculture' }
]

export const categorie_piante = [
    { value: 'FRUTTA_E_VERDURA', label: 'Frutta e verdura' },
    { value: 'FIORI_E_PIANTE_ORNAMENTALI', label: 'Fiori e Piante Ornamentali' },
    { value: 'CULTURE_COMBINABILI_COLTIVAZIONI_ALL_APERTO', label: `Culture Combinabili (coltivazioni all'aperto)` },
    { value: 'MATERIALE_DI_MOLTIPLICAZIONE_DELLE_PIANTE', label: 'Materiale di moltiplicazione delle piante' },
    { value: 'TE', label: 'Tè' },
    { value: 'LUPPOLO', label: 'Luppolo' }
]

export const opzioni_certificazione_IFA = [
    { value: 'OPZIONE_1_PRODUTTORE_CON_SITO_SINGOLO', label: 'Opzione 1 - Produttore con sito singolo' },
    { value: 'OPZIONE_1_PRODUTTORE_MULTISITO_SENZA_SGQ', label: 'Opzione 1 - Produttore multisito senza SGQ' },
    { value: 'OPZIONE_1_PRODUTTORE_MULTISITO_CON_SGQ', label: 'Opzione 1 - Produttore multisito con SGQ' },
    { value: 'OPZIONE_2_CERTIFICAZIONE_DI_GRUPPO', label: 'Opzione 2 - Certificazione di gruppo' },
]

export const manipolazione = [
    { value: 'NULL', label: 'Nessuna' },
    { value: 'CAMPO', label: 'Campo' },
    { value: 'MAGAZZINO', label: 'Magazzino' },
    { value: 'CAMPO_E_MAGAZZINO', label: 'Campo e Magazzino' }
]

export const yes_no = [
    { value: 'SI', label: 'SI' },
    { value: 'NO', label: 'NO' }
]

export const opzioni_certificazione_CoC = [
    { value: 'OPZIONE_1_CERTIFICAZIONE_INDIVIDUALE', label: 'Opzione 1 - Certificazione individuale' },
    { value: 'OPZIONE_1_SITI_SINGOLI', label: 'Opzione 1 - Siti singoli ' },
    { value: 'OPZIONE_1_MULTISITO', label: 'Opzione 1 - Multisito' },
    { value: 'OPZIONE_1_MULTISITO_PER_NEGOZI_AL_DETTAGLIO_E_CATENE_DI_RISTORANTI_IN_FRANCHISING', label: 'Opzione 1 - Multisito per negozi al dettaglio e catene di ristoranti in franchising' }
]

export const addonSelect = [
    { value: 'GRASP', label: 'GRASP' },
    { value: 'TRASPARENZA_SUI_PESTICIDI_DI_COOP_ITALIA', label: 'TRASPARENZA SUI PESTICIDI DI COOP ITALIA ' },
    { value: 'SPRING', label: 'SPRING ' }
]

export const skillLevels = [
    { value: 'SUFFICIENTE', label: 'Sufficiente' },
    { value: 'DISCRETA', label: 'Discreta' },
    { value: 'BUONA', label: 'Buona' },
    { value: 'OTTIMA', label: 'Ottima' },
]

// countries.js

export const countries = [
    { label: "Afghanistan", value: "AF" },
    { label: "Albania", value: "AL" },
    { label: "Algeria", value: "DZ" },
    { label: "Andorra", value: "AD" },
    { label: "Angola", value: "AO" },
    { label: "Antigua and Barbuda", value: "AG" },
    { label: "Argentina", value: "AR" },
    { label: "Armenia", value: "AM" },
    { label: "Australia", value: "AU" },
    { label: "Austria", value: "AT" },
    { label: "Azerbaijan", value: "AZ" },
    { label: "Bahamas", value: "BS" },
    { label: "Bahrain", value: "BH" },
    { label: "Bangladesh", value: "BD" },
    { label: "Barbados", value: "BB" },
    { label: "Belarus", value: "BY" },
    { label: "Belgium", value: "BE" },
    { label: "Belize", value: "BZ" },
    { label: "Benin", value: "BJ" },
    { label: "Bhutan", value: "BT" },
    { label: "Bolivia", value: "BO" },
    { label: "Bosnia and Herzegovina", value: "BA" },
    { label: "Botswana", value: "BW" },
    { label: "Brazil", value: "BR" },
    { label: "Brunei", value: "BN" },
    { label: "Bulgaria", value: "BG" },
    { label: "Burkina Faso", value: "BF" },
    { label: "Burundi", value: "BI" },
    { label: "Cabo Verde", value: "CV" },
    { label: "Cambodia", value: "KH" },
    { label: "Cameroon", value: "CM" },
    { label: "Canada", value: "CA" },
    { label: "Central African Republic", value: "CF" },
    { label: "Chad", value: "TD" },
    { label: "Chile", value: "CL" },
    { label: "China", value: "CN" },
    { label: "Colombia", value: "CO" },
    { label: "Comoros", value: "KM" },
    { label: "Congo, Democratic Republic of the", value: "CD" },
    { label: "Congo, Republic of the", value: "CG" },
    { label: "Costa Rica", value: "CR" },
    { label: "Croatia", value: "HR" },
    { label: "Cuba", value: "CU" },
    { label: "Cyprus", value: "CY" },
    { label: "Czech Republic", value: "CZ" },
    { label: "Denmark", value: "DK" },
    { label: "Djibouti", value: "DJ" },
    { label: "Dominica", value: "DM" },
    { label: "Dominican Republic", value: "DO" },
    { label: "Ecuador", value: "EC" },
    { label: "Egypt", value: "EG" },
    { label: "El Salvador", value: "SV" },
    { label: "Equatorial Guinea", value: "GQ" },
    { label: "Eritrea", value: "ER" },
    { label: "Estonia", value: "EE" },
    { label: "Eswatini", value: "SZ" },
    { label: "Ethiopia", value: "ET" },
    { label: "Fiji", value: "FJ" },
    { label: "Finland", value: "FI" },
    { label: "France", value: "FR" },
    { label: "Gabon", value: "GA" },
    { label: "Gambia", value: "GM" },
    { label: "Georgia", value: "GE" },
    { label: "Germany", value: "DE" },
    { label: "Ghana", value: "GH" },
    { label: "Greece", value: "GR" },
    { label: "Grenada", value: "GD" },
    { label: "Guatemala", value: "GT" },
    { label: "Guinea", value: "GN" },
    { label: "Guinea-Bissau", value: "GW" },
    { label: "Guyana", value: "GY" },
    { label: "Haiti", value: "HT" },
    { label: "Honduras", value: "HN" },
    { label: "Hungary", value: "HU" },
    { label: "Iceland", value: "IS" },
    { label: "India", value: "IN" },
    { label: "Indonesia", value: "ID" },
    { label: "Iran", value: "IR" },
    { label: "Iraq", value: "IQ" },
    { label: "Ireland", value: "IE" },
    { label: "Israel", value: "IL" },
    { label: "Italy", value: "IT" },
    { label: "Jamaica", value: "JM" },
    { label: "Japan", value: "JP" },
    { label: "Jordan", value: "JO" },
    { label: "Kazakhstan", value: "KZ" },
    { label: "Kenya", value: "KE" },
    { label: "Kiribati", value: "KI" },
    { label: "Korea, North", value: "KP" },
    { label: "Korea, South", value: "KR" },
    { label: "Kuwait", value: "KW" },
    { label: "Kyrgyzstan", value: "KG" },
    { label: "Laos", value: "LA" },
    { label: "Latvia", value: "LV" },
    { label: "Lebanon", value: "LB" },
    { label: "Lesotho", value: "LS" },
    { label: "Liberia", value: "LR" },
    { label: "Libya", value: "LY" },
    { label: "Liechtenstein", value: "LI" },
    { label: "Lithuania", value: "LT" },
    { label: "Luxembourg", value: "LU" },
    { label: "Madagascar", value: "MG" },
    { label: "Malawi", value: "MW" },
    { label: "Malaysia", value: "MY" },
    { label: "Maldives", value: "MV" },
    { label: "Mali", value: "ML" },
    { label: "Malta", value: "MT" },
    { label: "Marshall Islands", value: "MH" },
    { label: "Mauritania", value: "MR" },
    { label: "Mauritius", value: "MU" },
    { label: "Mexico", value: "MX" },
    { label: "Micronesia", value: "FM" },
    { label: "Moldova", value: "MD" },
    { label: "Monaco", value: "MC" },
    { label: "Mongolia", value: "MN" },
    { label: "Montenegro", value: "ME" },
    { label: "Morocco", value: "MA" },
    { label: "Mozambique", value: "MZ" },
    { label: "Myanmar", value: "MM" },
    { label: "Namibia", value: "NA" },
    { label: "Nauru", value: "NR" },
    { label: "Nepal", value: "NP" },
    { label: "Netherlands", value: "NL" },
    { label: "New Zealand", value: "NZ" },
    { label: "Nicaragua", value: "NI" },
    { label: "Niger", value: "NE" },
    { label: "Nigeria", value: "NG" },
    { label: "North Macedonia", value: "MK" },
    { label: "Norway", value: "NO" },
    { label: "Oman", value: "OM" },
    { label: "Pakistan", value: "PK" },
    { label: "Palau", value: "PW" },
    { label: "Panama", value: "PA" },
    { label: "Papua New Guinea", value: "PG" },
    { label: "Paraguay", value: "PY" },
    { label: "Peru", value: "PE" },
    { label: "Philippines", value: "PH" },
    { label: "Poland", value: "PL" },
    { label: "Portugal", value: "PT" },
    { label: "Qatar", value: "QA" },
    { label: "Romania", value: "RO" },
    { label: "Russia", value: "RU" },
    { label: "Rwanda", value: "RW" },
    { label: "Saint Kitts and Nevis", value: "KN" },
    { label: "Saint Lucia", value: "LC" },
    { label: "Saint Vincent and the Grenadines", value: "VC" },
    { label: "Samoa", value: "WS" },
    { label: "San Marino", value: "SM" },
    { label: "Sao Tome and Principe", value: "ST" },
    { label: "Saudi Arabia", value: "SA" },
    { label: "Senegal", value: "SN" },
    { label: "Serbia", value: "RS" },
    { label: "Seychelles", value: "SC" },
    { label: "Sierra Leone", value: "SL" },
    { label: "Singapore", value: "SG" },
    { label: "Slovakia", value: "SK" },
    { label: "Slovenia", value: "SI" },
    { label: "Solomon Islands", value: "SB" },
    { label: "Somalia", value: "SO" },
    { label: "South Africa", value: "ZA" },
    { label: "South Sudan", value: "SS" },
    { label: "Spain", value: "ES" },
    { label: "Sri Lanka", value: "LK" },
    { label: "Sudan", value: "SD" },
    { label: "Suriname", value: "SR" },
    { label: "Sweden", value: "SE" },
    { label: "Switzerland", value: "CH" },
    { label: "Syria", value: "SY" },
    { label: "Taiwan", value: "TW" },
    { label: "Tajikistan", value: "TJ" },
    { label: "Tanzania", value: "TZ" },
    { label: "Thailand", value: "TH" },
    { label: "Timor-Leste", value: "TL" },
    { label: "Togo", value: "TG" },
    { label: "Tonga", value: "TO" },
    { label: "Trinidad and Tobago", value: "TT" },
    { label: "Tunisia", value: "TN" },
    { label: "Turkey", value: "TR" },
    { label: "Turkmenistan", value: "TM" },
    { label: "Tuvalu", value: "TV" },
    { label: "Uganda", value: "UG" },
    { label: "Ukraine", value: "UA" },
    { label: "United Arab Emirates", value: "AE" },
    { label: "United Kingdom", value: "GB" },
    { label: "United States", value: "US" },
    { label: "Uruguay", value: "UY" },
    { label: "Uzbekistan", value: "UZ" },
    { label: "Vanuatu", value: "VU" },
    { label: "Vatican City", value: "VA" },
    { label: "Venezuela", value: "VE" },
    { label: "Vietnam", value: "VN" },
    { label: "Yemen", value: "YE" },
    { label: "Zambia", value: "ZM" },
    { label: "Zimbabwe", value: "ZW" }
];


export const headquartersOptions: OptionType[] = [
    { value: 'SC', label: 'SC' },
    { value: 'CL', label: 'CL' },
    { value: 'IS', label: 'IS' },
    { value: 'TV', label: 'TV' },
    { value: 'PU', label: 'PU' },
    { value: 'BA', label: 'BA' },
    { value: 'DG', label: 'DG' },
]

export const statusLiberatoria: OptionType[] = [
    { value: 'EVASA', label: 'Evasa' },
    { value: 'NON_EVASA', label: 'Non Evasa' }
]

export const yearOptions = (() => {
    const currentYear = new Date().getFullYear();
    const startYear = 2015;
    return Array.from({ length: currentYear - startYear + 1 }, (_, index) => {
        const year = currentYear - index;
        return { value: year.toString(), label: year.toString() };
    });
})();

export const typologyOptions: OptionType[] = [
    { value: 'CDX_DIPENDENTE', label: 'CDX Dipendente' },
    { value: 'CDX_C002', label: 'CDX C002' },
    { value: 'CDX_C008', label: 'CDX C008' },
    { value: 'CDX_C009', label: 'CDX C009' },
    { value: 'CDX_C010', label: 'CDX C010' },
    { value: 'CDX_CSI', label: 'CDX CSI' },
    { value: 'CDX_CDX_GG_017', label: 'CDX CDX_GG_017' },
]

export const officeOptions: OptionType[] = [
    { value: 'Amm', label: 'Amm - Amministratore' },
    { value: 'DG', label: 'DG - Direzione' },
    { value: 'UCO', label: 'UCO - Ufficio Controllo' },
    { value: 'UCE', label: 'UCE - Ufficio Certificazione' },
    { value: 'UST', label: 'UST - Segreteria Tecnica' },
    { value: 'UCA', label: 'UCA - Amministrazione' },
    { value: 'CL', label: 'Sede Calabria' },
    { value: 'IS', label: 'Sede Italia Settentrionale' }
]

export const sotOrOfficeOptions: OptionType[] = [
    { value: 'Amm', label: 'Amm - Amministratore' },
    { value: 'SC', label: 'Sede Centrale' },
    { value: 'CL', label: 'SOT Calabria' },
    { value: 'IS', label: 'SOT Italia Settentrionale' },
    { value: 'PU', label: 'SOT Puglia' },
    { value: 'BA', label: 'SOT Basilicata' },
    { value: 'IM', label: 'SOT Italia Meridionale' },
    { value: 'TV', label: 'SOT Triveneto' },
    { value: 'DG', label: 'DG - Direzione' },
    { value: 'UCO', label: 'UCO - Ufficio Controllo' },
    { value: 'UCE', label: 'UCE - Ufficio Certificazione' },
    { value: 'UST', label: 'UST - Segreteria Tecnica' },
    { value: 'UCA', label: 'UCA - Amministrazione' },
    { value: 'IS', label: 'Sede Italia Settentrionale' }
]

export const revisioneOptions: OptionType[] = [
    { value: 'REVISIONE_0', label: 'Rev. 1' },
    { value: 'REVISIONE_1', label: 'Rev. 2' },
    { value: 'REVISIONE_2', label: 'Rev. 3' },
    { value: 'REVISIONE_3', label: 'Rev. 4' },
]

export const fiscalRegimeOptions: OptionType[] = [
    { value: 'DIPENDENTE', label: 'Dipendente' },
    { value: 'FORFETTARIO_CON_CASSA', label: 'Forfettario con cassa' },
    { value: 'FORFETTARIO_CON_CASSA_4_PERCENTO', label: 'Forfettario con cassa 4%' },
    { value: 'FORFETTARIO_CON_RIVALSA_INPS', label: 'Forfettario con rivalsa INPS' },
    { value: 'FORFETTARIO_SENZA_CASSA_E_RIVALSA_INPS', label: 'orfettario senza cassa e rivalsa INPS' },
    { value: 'MINIMO_CON_CASSA', label: 'Minimo con cassa' },
    { value: 'MINIMO_CON_CASSA_AL_4_PERCENTO', label: 'Minimo con cassa al 4%' },
    { value: 'MINIMO_CON_RIVALSA_INPS', label: 'Minimo con rivalsa INPS' },
    { value: 'PROFESSIONISTA_OCCASIONALE_ECCEDENTE_A_5000_EURO', label: 'Professionista occasionale eccedente a 5000 euro' },
    { value: 'PROFESSIONISTA_OCCASIONALE_INFERIORE_A_5000_EURO', label: 'Professionista occasionale inferiore a 5000 euro' },
    { value: 'PROFESSIONISTI_CON_REGIME_IVA_ORDINARIO', label: 'Professionisti con regime IVA ordinario' },
    { value: 'PROFESSIONISTI_CON_REGIME_IVA_ORDINARIO_CON_CASSA_AL_4_PERCENTO', label: 'Professionisti con regime IVA ordinario con cassa al 4%' },
    { value: 'PROFESSIONISTI_CON_REGIME_IVA_ORDINARIO_CON_RIVALSA_INPS', label: 'Professionisti con regime IVA ordinario con rivalsa INPS' },
]

export const resultOptions: OptionType[] = [
    { value: 'POSITIVO', label: 'Positivo' },
    { value: 'NEGATIVO', label: 'Negativo' }
]

export const activityOptions: OptionType[] = [
    { value: 'ADMIN', label: 'Admin' },
    { value: 'AMMINISTRATORE', label: 'Amministratore' },
    { value: 'DIRETTORE_GENERALE', label: 'Direttore generale' },
    { value: 'RESPONSABILE_ASSICURAZIONE_QUALITA', label: 'Responsabile assicurazione qualità' },
    { value: 'RESPONSABILE_UFFICIO_CONTROLLO', label: 'Responsabile ufficio controllo' },
    { value: 'FUNZIONARI_UFFICIO_CONTROLLO', label: 'Funzionari ufficio controllo' },
    { value: 'RESPONSABILE_UFFICIO_CERTIFICAZIONE', label: 'Responsabile ufficio certificazione' },
    { value: 'FUNZIONARI_UFFICIO_CERTIFICAZIONE', label: 'Funzionari ufficio certificazione' },
    { value: 'RESPONSABILE_UFFICIO_SEGRETERIA_TECNICA', label: 'Responsabile ufficio segreteria tecnica' },
    { value: 'FUNZIONARI_UFFICIO_SEGRETERIA_TECNICA', label: 'Funzionari ufficio segreteria tecnica' },
    { value: 'FUNZIONARI_AMMINISTRAZIONE', label: 'Funzionari amministrazione' },
    { value: "MEMBRO_SUPPLENTE_DELL_ORGANO_COLLEGIALE_DI_DELIBERA", label: "Membro supplente dell'organo collegiale di delibera" },
    { value: 'VALUTARE_PROCESSO_DI_CONTROLLO', label: 'Valutare processo di controllo' },
    { value: 'RIESAME_PROCESSO_DI_CONTROLLO', label: 'Riesame processo di controllo' },
    { value: 'ORGANO_COLLEGIALE_DI_DELIBERA', label: 'Orango collegiale di delibera' },
    { value: 'COMITATO_SALVAGUARDIA_IMPARZIALITA', label: 'Comitato salvaguardia imparzialità' },
    { value: 'FORMATORE_INTRAZIENDALE_GLOBAL_GAP', label: 'Formatore intraziendale globalGAP' },
    { value: 'SCHEME_MANAGER', label: 'Scheme manager' },
    { value: 'COLLABORATORE_SCHEME_MANAGER', label: 'Collaboratore scheme manager' },
    { value: 'ATTIVITA_DI_RIESAME_DECISIONE', label: 'Attività di riesame decisione' },
    { value: 'RESPONSABILE_SEDE_TERRITORIALE', label: 'Responsabile sede territoriale' },
    { value: 'COLLABORATORE_SEDE_TERRITORIALE', label: 'Collaboratore sede territoriale' },
    { value: 'REFERENTE_REGIONALE', label: 'Referente regionale' },
    { value: 'GESTIONE_DATI_INFORMATICI', label: 'Gestione dati informatici' },
    { value: 'VERIFICATORE_VERIFICHE_ISPETTIVE_INTERNE', label: 'Verificatore verifiche ispettive interne' },
    { value: 'ORGANO_DI_VIGILANZA_d_legislativo_n_231_2001', label: 'Organo di vigilanza d legislativo n. 231 2001' },
    { value: 'PERSONALE_ISPETTIVO', label: 'Personale ispettivo' },
    { value: 'CLIENTE', label: 'Cliente' },
]

export const rolesOptions: OptionType[] = [
    { value: 'ADMIN', label: 'Admin' },
    { value: 'AMMINISTRATORE', label: 'Amministratore' },
    { value: 'DIRETTORE_GENERALE', label: 'Direttore generale' },
    { value: 'RESPONSABILE_ASSICURAZIONE_QUALITA', label: 'Responsabile assicurazione qualità' },
    { value: 'RESPONSABILE_UFFICIO_CONTROLLO', label: 'Responsabile ufficio controllo' },
    { value: 'FUNZIONARI_UFFICIO_CONTROLLO', label: 'Funzionari ufficio controllo' },
    { value: 'RESPONSABILE_UFFICIO_CERTIFICAZIONE', label: 'Responsabile ufficio certificazione' },
    { value: 'FUNZIONARI_UFFICIO_CERTIFICAZIONE', label: 'Funzionari ufficio certificazione' },
    { value: 'RESPONSABILE_UFFICIO_SEGRETERIA_TECNICA', label: 'Responsabile ufficio segreteria tecnica' },
    { value: 'FUNZIONARI_UFFICIO_SEGRETERIA_TECNICA', label: 'Funzionari ufficio segreteria tecnica' },
    { value: 'FUNZIONARI_AMMINISTRAZIONE', label: 'Funzionari amministrazione' },
    { value: "MEMBRO_SUPPLENTE_DELL_ORGANO_COLLEGIALE_DI_DELIBERA", label: "Membro supplente dell'organo collegiale di delibera" },
    { value: 'VALUTARE_PROCESSO_DI_CONTROLLO', label: 'Valutare processo di controllo' },
    { value: 'RIESAME_PROCESSO_DI_CONTROLLO', label: 'Riesame processo di controllo' },
    { value: 'ORGANO_COLLEGIALE_DI_DELIBERA', label: 'Orango collegiale di delibera' },
    { value: 'COMITATO_SALVAGUARDIA_IMPARZIALITA', label: 'Comitato salvaguardia imparzialità' },
    { value: 'FORMATORE_INTRAZIENDALE_GLOBAL_GAP', label: 'Formatore intraziendale globalGAP' },
    { value: 'SCHEME_MANAGER', label: 'Scheme manager' },
    { value: 'COLLABORATORE_SCHEME_MANAGER', label: 'Collaboratore scheme manager' },
    { value: 'ATTIVITA_DI_RIESAME_DECISIONE', label: 'Attività di riesame decisione' },
    { value: 'RESPONSABILE_SEDE_TERRITORIALE', label: 'Responsabile sede territoriale' },
    { value: 'COLLABORATORE_SEDE_TERRITORIALE', label: 'Collaboratore sede territoriale' },
    { value: 'REFERENTE_REGIONALE', label: 'Referente regionale' },
    { value: 'GESTIONE_DATI_INFORMATICI', label: 'Gestione dati informatici' },
    { value: 'VERIFICATORE_VERIFICHE_ISPETTIVE_INTERNE', label: 'Verificatore verifiche ispettive interne' },
    { value: 'ORGANO_DI_VIGILANZA_d_legislativo_n_231_2001', label: 'Organo di vigilanza d legislativo n. 231 2001' },
    { value: 'PERSONALE_ISPETTIVO', label: 'Personale ispettivo' },
    { value: 'CLIENTE', label: 'Cliente' },
]

export const valutatoreOptions: OptionType[] = [
    { value: 'Fasano Antonino', label: 'Fasano Antonino' },
    { value: `D'Agosta Francesco`, label: `D'Agosta Francesco` }
]

export const trainingActivityOptions: OptionType[] = [
    { value: 'AUDIT', label: 'Audit' },
    { value: 'CORSO_FORMATIVO_E_DI_ADDESTRAMENTO', label: 'Corso formativo e di addestramento' },
    { value: 'ATTIVITA_FORMATIVA_TEORICA', label: 'Attività formativa teorica' },
    { value: 'ATTIVITA_FORMATIVA_TEORICA_INTERNA', label: 'Attività formativa teorica interna' },
    { value: 'ATTIVITA_FORMATIVA_TEORICA_E_PRATICA', label: 'Attività formativa teorica e pratica' },
    { value: 'FORMAZIONE_E_ADDESTRAMENTO_SUL_PROGRAMMA_CODINFO', label: 'Formazione e addestramento sul programma Codinfo' },
    { value: 'RAFFORZAMENTO_DELL_ATTIVITA_FORMATIVA_TEORICA', label: `Rafforzamento dell'attività formativa teorica` },
    { value: 'SEMINARIO_DI_AGGIORNAMENTO_E_ADDESTRAMENTO_PER_I_RESPONSABILI_REGIONALI', label: 'Seminario di aggiornamento e addestramento per i responsabili regionali' },
    { value: 'CORSO_INTERNO_PER_IL_CORPO_ISPETTIVO', label: 'Corso interno per il corpo ispettivo' },
    { value: 'ADDESTRAMENTO_IN_CAMPO_CON_TECNICO_ISPETTORE', label: 'Addestramento in campo con tecnico ispettore' },
    { value: 'AUDIT_E_ADDESTRAMENTO_INTERNO', label: 'Audit e addestramento interno' },
    { value: 'ATTIVITA_FORMATIVA_TEORICA_MIRATA_ALLE_CRITICITA_SPECIFICHE', label: 'Attività formativa teorica mirata alle criticità specifiche' },
    { value: 'VISITE_ISPETTIVE_PRESSO_OPERATORI_CODEX_AUDITING', label: 'Visite ispettive presso operatori Codex auditing' },
    { value: 'VISITA_ISPETTIVA_IN_AFFIANCAMENTO', label: 'Visita ispettiva in affiancamento' },
    { value: 'AGGIORNAMENTO_AL_CORPO_ISPETTIVO', label: 'Aggiornamento al corpo ispettivo' },
    { value: 'AGGIORNAMENTO_AL_PERSONALE_DELLA_SEGRETERIA_TECNICA', label: 'Aggiornamento al personale della segreteria tecnica' },
    { value: 'AGGIORNAMENTO_AL_PERSONALE_DELL_UFFICIO_CONTROLLO', label: `Aggiornamento al personale dell'ufficio controllo` },
    { value: 'AGGIORNAMENTO_AL_PERSONALE_DELL_UFFICIO_CERTIFICAZIONE', label: `Aggiornamento al personale dell'ufficio certificazione` },
    { value: 'ATTIVITA_FORMATIVA_TEORICA_E_PRATICA_INDIVIDUALE', label: 'Attività formativa teorica e pratica individuale' },
    { value: 'ATTIVITA_FORMATIVA_TEORICA_E_PRATICA_PERSONALE_CODEX', label: 'Attività formativa teorica e pratica personale Codex' },
]

export enum WebinarOptions {
    WEBINAR = 'WEBINAR',
    SEDE = 'SEDE',
}

export const webinarOptionsValue: OptionType[] = [
    { value: WebinarOptions.WEBINAR, label: 'Webinar' },
    { value: WebinarOptions.SEDE, label: 'In Presenza' }
]

export const entryMeansOptions: OptionType[] = [
    { value: 'POSTA_PRIORITARIA', label: 'Posta Prioritaria' },
    { value: 'RACCOMANDATA', label: 'Raccomandata' },
    { value: 'RACCOMANDATA_A_MANO', label: 'Raccomandata a mano' },
    { value: 'RACCOMANDATA_1', label: 'Raccomandata 1' },
    { value: 'CORRIERE', label: 'Corriere' },
    { value: 'POSTA_ELETTRONICA', label: 'Posta Elettronica' },
    { value: 'POSTA_ELETTRONICA_CERTIFICATA', label: 'Posta Elettronica Certificata' },
    { value: 'FAX', label: 'Fax' },
    { value: 'WEB', label: 'Web' },
]

export const destinationOffice: OptionType[] = [
    { value: 'DR', label: 'DR' },
    { value: 'MPC', label: 'MPC' },
    { value: 'Amm', label: 'Amm' },
    { value: 'SM', label: 'SM' },
    { value: 'UCE', label: 'UCE' },
    { value: 'UCO', label: 'UCO' },
    { value: 'UST', label: 'UST' },
    { value: 'UCA', label: 'UCA' },
    { value: 'IS', label: 'IS' },
    { value: 'PU', label: 'PU' },
    { value: 'BA', label: 'BA' },
    { value: 'IS', label: 'IS' },
    { value: 'CL', label: 'CL' },
    { value: 'SC', label: 'Sc' },
]

export enum DestinationOfficesType {
    DIREZIONE = 'DR',
    MON_PEC_DIREZIONE = 'MPC',
    AMM_UNICO = 'Amm',
    SCHEME_MANAGER_GG = 'SM',
    UFFICIO_CERT = 'UCE',
    UFFICIO_CONTR = 'UCO',
    UFFICIO_SEGR_TEC = 'UST',
    UFFICIO_CONT_AMM = 'UCA',
    SOT_IS = 'IS',
    SOT_PU = 'PU',
    SOT_BA = 'BA',
    SOT_CL = 'CL'
}

export const departureMeansOptions: OptionType[] = [
    { value: 'POSTA_PRIORITARIA', label: 'Posta Prioritaria' },
    { value: 'RACCOMANDATA', label: 'Raccomandata' },
    { value: 'RACCOMANDATA_A_MANO', label: 'Raccomandata a mano' },
    { value: 'RACCOMANDATA_1', label: 'Raccomandata 1' },
    { value: 'CORRIERE', label: 'Corriere' },
    { value: 'POSTA_ELETTRONICA', label: 'Posta Elettronica' },
    { value: 'POSTA_ELETTRONICA_CERTIFICATA', label: 'Posta Elettronica Certificata' },
    { value: 'FAX', label: 'Fax' },
]

export enum DeliveryManagementType {
    PEC = 'PEC',
    RACC_AR = 'RACC_AR',
    CORRIERE = 'CORRIERE',
    RACC_M = 'RACC_M',
    POST_E = 'PE'
}

export const EPAttachmentGroupOptions: OptionType[] = [
    { value: '1-3-12', label: 'Group #1' },
    { value: '2-5', label: 'Group #2' },
    { value: '14-28', label: 'Group #3' },
    { value: '3-15-24', label: 'Group #4' },
    { value: '1-2-3', label: 'Group #5' },
]

export const PPAttachmentGroupOptions: OptionType[] = [
    { value: '1-3-12', label: 'Group #1' },
    { value: '2-5', label: 'Group #2' },
    { value: '14-28', label: 'Group #3' },
    { value: '3-15-24', label: 'Group #4' },
    { value: '1-2-3', label: 'Group #5' },
]

export interface ProtocolDataBanner {
    protocol: string
    date: Date
}

export enum TrainingTypes {
    MANUALE = 'FORMAZIONE_TEORICA_SUL_MANUALE_CODEX',
    NORMATIVA = 'FORMAZIONE_TEORICA_SULLA_NORMATIVA',
    PRATICA = 'FORMAZIONE_PRATICA'
}

export const ReportingTypologyOption: OptionType[] = [
    { value: ReportingType.OFIS, label: 'OFIS' },
    { value: ReportingType.PRODOTTO_NON_CONFORME, label: 'Prodotto non conforme' },
    { value: ReportingType.ANALISI_CON_ESITO_NON_CONFORME, label: 'Analisi con esito non conforme' },
    { value: ReportingType.ANALISI_CON_ESITO_CONFORME_CON_PRESENZA_DI_PRINCIPI_ATTIVI_NON_AMMESSI, label: 'Analisi con esito conforme con presenza di principi attivi non ammessi' },
    { value: ReportingType.VERIFICA_AUTORITA_DI_CONTROLLO, label: 'Verifica Autorità di Controllo' },
    { value: ReportingType.VERIFICA_ORGANISMO_DI_CONTROLLO, label: 'Verifica Organismo di Controllo' },
    { value: ReportingType.ALTRO, label: 'Altro' }
]

export const ReportingStatusOption: OptionType[] = [
    { value: ReportingInnerState.APERTA, label: 'Aperta' },
    { value: ReportingInnerState.IN_GESTIONE, label: 'In gestione' },
    { value: ReportingInnerState.CHIUSA, label: 'Chiusa' }
]

export const ReportingStateStatusOption: OptionType[] = [
    { value: ReportingOuterState.PRESA_IN_CARICO_DELLA_RICHIESTA, label: 'Presa in carico della richiesta' },
    { value: ReportingOuterState.PRESA_IN_CARICO_DELLA_RICHIESTA_E_COMUNICAZIONE_AL_MITTENTE, label: 'Presa in carico della richiesta e comunicazione al mittente' },
    { value: ReportingOuterState.COMUNICAZIONE_AL_MITTENTE, label: 'Comunicazione al mittente' },
    { value: ReportingOuterState.RICHIESTA_INTEGRAZIONE_DOCUMENTI, label: 'Richiesta Integrazione Documenti' },
    { value: ReportingOuterState.SOPPRESSIONE_CAUTELATIVA, label: 'Soppressione cautelativa' },
    { value: ReportingOuterState.PROVVEDIMENTO_DEFINITIVO, label: 'Provvedimento definitivo' },
    { value: ReportingOuterState.VISITA_ISPETTIVA, label: 'Visita Ispettiva' },
    { value: ReportingOuterState.CHIUSURA_SEGNALAZIONE_E_RISPOSTA_AL_MITTENTE, label: 'Chiusura Segnalazione e Risposta al Mittente' },
]

// BUSINESS REGISTER OPTIONS
export const BusinessRegisterTypologyRequestOptions: OptionType[] = [
    { value: BusinessRegisterRequestType.CARTACEI, label: 'Cartacei' },
    { value: BusinessRegisterRequestType.INFORMATIZZATI, label: 'Informatizzati' },
    { value: BusinessRegisterRequestType.ACCESSO_CODINFO_CLIENTI, label: 'Accesso Codinfo Clienti' },
]

export const BusinessRegisterRequestMotivationOptions: OptionType[] = [
    { value: BusinessRegisterRequestReason.EMISSIONE_PER_CLIENTE_IN_FASE_DI_AVVIO, label: 'Emissione per Cliente in Fase di avvio' },
    { value: BusinessRegisterRequestReason.EMISSIONE_A_SEGUITO_NOTIFICA_VARIAZIONE, label: 'Emissione a seguito Notifica Variazione' },
    { value: BusinessRegisterRequestReason.RICHIESTA_PER_REGISTRI_ESAURITI, label: 'Richiesta per Registri Esauriti' },
    { value: BusinessRegisterRequestReason.RICHIESTA_PER_REGISTRI_SMARRITI, label: 'Richiesta per Registri Smarriti' },
    { value: BusinessRegisterRequestReason.RICHIESTA_REGISTRI_INFORMATIZZATI, label: 'Emissione Regitri Informatizzati' },
]

// PAC OPTIONS
export const PACVisitingModeOptions: OptionType[] = [
    { value: PACVisitingModeEnum.ANNUNCIATA, label: 'Annunciata' },
    { value: PACVisitingModeEnum.NON_ANNUNCIATA, label: 'Non annunciata' },
    { value: PACVisitingModeEnum.CON_PREAVVISO, label: 'Con preavviso' },
    { value: PACVisitingModeEnum.SENZA_PREAVVISO, label: 'Senza preavviso' }
]

export const PACVisitingTypeOptions: OptionType[] = [
    { value: PACVisitingTypeEnum.CONTROLLO_ORDINARIO, label: 'Controllo Ordinario' },
    { value: PACVisitingTypeEnum.CONTROLLO_ANNUALE, label: 'Controllo Annuale' },
    { value: PACVisitingTypeEnum.CONTROLLO_AGGIUNTIVO, label: 'Controllo Aggiuntivo' },
    { value: PACVisitingTypeEnum.CONTROLLO_FASE_AVVIO, label: 'Fase di avvio-controllo in ingresso' },
    { value: PACVisitingTypeEnum.CONTROLLO_STRAORDINARIO, label: 'Controllo Straordinario' },
    { value: PACVisitingTypeEnum.CONTROLLO_MIRATO, label: 'Controllo Mirato' },
]

export const SingleMonthOptions: OptionType[] = [
    { value: '1', label: 'Gennaio' },
    { value: '2', label: 'Febbraio' },
    { value: '3', label: 'Marzo' },
    { value: '4', label: 'Aprile' },
    { value: '5', label: 'Maggio' },
    { value: '6', label: 'Giugno' },
    { value: '7', label: 'Luglio' },
    { value: '8', label: 'Agosto' },
    { value: '9', label: 'Settembre' },
    { value: '10', label: 'Ottobre' },
    { value: '11', label: 'Novembre' },
    { value: '12', label: 'Dicembre' }
]

export const MultipleMonthOptions: OptionType[] = [
    { value: '1', label: 'Gennaio' },
    { value: '1-2', label: 'Gennaio/Febbraio' },
    { value: '1-2-3', label: 'Gennaio/Febbraio/Marzo' },
    { value: '2', label: 'Febbraio' },
    { value: '2-3', label: 'Febbraio/Marzo' },
    { value: '2-3-4', label: 'Febbraio/Marzo/Aprile' },
    { value: '3', label: 'Marzo' },
    { value: '3-4', label: 'Marzo/Aprile' },
    { value: '3-4-5', label: 'Marzo/Aprile/Maggio' },
    { value: '4', label: 'Aprile' },
    { value: '4-5', label: 'Aprile/Maggio' },
    { value: '4-5-6', label: 'Aprile/Maggio/Giugno' },
    { value: '5', label: 'Maggio' },
    { value: '5-6', label: 'Maggio/Giugno' },
    { value: '5-6-7', label: 'Maggio/Giugno/Luglio' },
    { value: '6', label: 'Giugno' },
    { value: '6-7', label: 'Giugno/Luglio' },
    { value: '6-7-8', label: 'Giugno/Luglio/Agosto' },
    { value: '7', label: 'Luglio' },
    { value: '7-8', label: 'Luglio/Agosto' },
    { value: '7-8-9', label: 'Luglio/Agosto/Settembre' },
    { value: '8', label: 'Agosto' },
    { value: '8-9', label: 'Agosto/Settembre' },
    { value: '8-9-10', label: 'Agosto/Settembre/Ottobre' },
    { value: '9', label: 'Settembre' },
    { value: '9-10', label: 'Settembre/Ottobre' },
    { value: '9-10-11', label: 'Settembre/Ottobre/Novembre' },
    { value: '10', label: 'Ottobre' },
    { value: '10-11', label: 'Ottobre/Novembre' },
    { value: '10-11-12', label: 'Ottobre/Novembre/Dicembre' },
    { value: '11', label: 'Novembre' },
    { value: '11-12', label: 'Novembre/Dicembre' },
    { value: '12', label: 'Dicembre' }
]

export const tipologiaRichiestaComplianceRequest: OptionType[] = [

    { label: "Richiesta conformità prodotto", value: 'RICHIESTA_CONFORMITA_PRODOTTO' },
    { label: "Sospetto di prodotto non conforme", value: 'SOSPETTO_DI_PRODOTTO_NON_CONFORME' }

]

export const statoRichiestaComplianceRequest: OptionType[] = [

    { label: "Presa in Carico della Richiesta", value: 'PRESA_IN_CARICO_DELLA_RICHIESTA' },
    { label: "Richiesta Informazioni Aggiuntive al Mittente", value: 'RICHIESTA_INFORMAZIONI_AGGIUNTIVE_AL_MITTENTE' },
    { label: "Richiesta Integrazione Documenti", value: 'RICHIESTA_INTEGRAZIONE_DOCUMENTI' },
    { label: "Soppressione Cautelativa", value: 'SOPPRESSIONE_CAUTELATIVA' },
    { label: "Provvedimento definitivo", value: 'PROVVEDIMENTO_DEFINITIVO' },
    { label: "Chiusa - Invio risposta", value: 'CHIUSA_INVIO_RISPOSTA' },
]

export const codiceNC: OptionType[] = [
    { label: 'A1.01', value: 'A1.01' },
    { label: 'A1.02', value: 'A1.02' },
    { label: 'A1.03', value: 'A1.03' },
]

/* CONVERSION PERIOD */
export const ConversionPeriodStateOptions: OptionType[] = [
    { value: ConversionPeriodState.IN_CORSO, label: 'In Corso' },
    { value: ConversionPeriodState.IN_ATTESA_DEL_CONTROLLO_ISPETTIVO, label: 'In attesa del controllo ispettivo' },
    { value: ConversionPeriodState.IN_ATTESA_DI_DOCUMENTAZIONE, label: 'In attesa di documentazione' },
    { value: ConversionPeriodState.APPROVATA, label: 'Approvata' },
    { value: ConversionPeriodState.APPROVATA_PER_SILENZIO_ASSENSO, label: 'Approvata per silenzio assenso' },
    { value: ConversionPeriodState.NON_APPROVATA, label: 'Non approvata' },
    { value: ConversionPeriodState.RICHIESTA_ANNULLATA_DAL_CLIENTE, label: 'Richiesta annullata dal cliente' },
    { value: ConversionPeriodState.RICHIESTA_ARCHIVIATA_DA_CODEX_SRL, label: 'Richiesta archiviata da Codex S.r.l.' },
]

/* CODEX SAMPLE */
export const CodexSampleStatusOptions: OptionType[] = [
    { value: CodexSampleChangeStatusEnum.IN_GIACENZA, label: 'In Giacenza' },
    { value: CodexSampleChangeStatusEnum.CONSEGNATA, label: 'Consegnata' },
    { value: CodexSampleChangeStatusEnum.DISTRUTTA, label: 'Annullata/Distrutta' },
    { value: CodexSampleChangeStatusEnum.SMARRITA, label: 'Smarrita' },
    { value: CodexSampleChangeStatusEnum.UTILIZZATA, label: 'Utilizzata' }
]

/* REINFORCED CONTROL MEASURE */

export const ReinforcedControlMeasureMotivationOptions: OptionType[] = [
    { value: ReinforcedMotivationsEnum.SU_RICHIESTA_DI_AUTORITA_COMPETENTI, label: "In casi di particolare gravità, a richiesta dell'autorità competente" },
    { value: ReinforcedMotivationsEnum.CLIENTE_CON_PIU_DI_3_RAPPORTI_OFIS, label: "Operatori soggetti a più di tre segnalazioni 'OFIS' (Organic Farming Information System) nell'arco di 2 anni (alla quarta segnalazione, cioè, vanno adottate le misure di controllo rinforzato)" },
    { value: ReinforcedMotivationsEnum.INFRAZIONE_IRREGOLARE, label: "Operatori a carico dei quali l'OdC ha emesso una irregolarità e/o infrazione a seguito di una segnalazione OFIS" },
    { value: ReinforcedMotivationsEnum.INDAGINI_PENALI, label: "Operatori oggetto di specifiche indagini di natura penale" },
    { value: ReinforcedMotivationsEnum.ALTRO, label: "ALTRO" },
]

/* TIME */

export const HourOptions: OptionType[] = Array.from({ length: 24 }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i < 9 ? "0" : "") + (i + 1).toString(),
}));

export const MinuteOptions: OptionType[] = Array.from({ length: 12 }, (_, i) => {
    const value = (i * 5).toString().padStart(2, "0");
    return { value, label: value };
});

/* SCHEDA DI CALCOLO */

export const schedaCalcoloYearsOptions = (() => {
    const lastYear = new Date().getFullYear() - 1;
    return Array.from({ length: 3 }, (_, index) => {
        const year = lastYear - index;
        return { value: year.toString(), label: year.toString() };
    });
})();

export const ServiceTypeNormoptions: OptionType[] = [
    { value: ServiceTypeNormEnum.BIODINAMICA, label: 'Biodinamica' },
    { value: ServiceTypeNormEnum.PRODUZIONE_INTEGRATA, label: 'Produzione Integrata' },
    { value: ServiceTypeNormEnum.DETERGENZA, label: 'Detergenza' },
    { value: ServiceTypeNormEnum.GLOBAL_GAP, label: 'Global G.A.P.' },
    { value: ServiceTypeNormEnum.QUALITA_SICURA, label: 'Qualità Sicura' },
    { value: ServiceTypeNormEnum.RESIDUO_ZERO, label: 'Residuo Zero' },
    { value: ServiceTypeNormEnum.NORMA_BIO, label: 'Biologica' },
    { value: ServiceTypeNormEnum.NICHEL_FREE, label: 'Nichel Free' },
]

export const ServiceTypeUnitOptions: OptionType[] = [
    { value: ServiceTypeUnitEnum.ORE, label: 'Ore/Minuti' },
    { value: ServiceTypeUnitEnum.GIORNI, label: 'Giorno' },
    { value: ServiceTypeUnitEnum.UNITA, label: 'Unità' },
]

/* NOTIFICATIONS */

export const NotificationReleaseStatusOptions: OptionType[] = [
    { value: ReleaseStatusEnum.RILASCIATA, label: 'Rilasciata' },
    { value: ReleaseStatusEnum.PUBBLICATA, label: 'Pubblicata' },
    { value: ReleaseStatusEnum.ARCHIVIATA, label: 'Archiviata' },
    { value: ReleaseStatusEnum.NON_VALIDA, label: 'Non Valida' },
    { value: ReleaseStatusEnum.NON_VALIDA_ODC, label: 'Non valida OdC' },
    { value: ReleaseStatusEnum.IDONEA, label: 'Idonea' },
    { value: ReleaseStatusEnum.ESCLUSA, label: 'Esclusa' },
    { value: ReleaseStatusEnum.CANCELLATA, label: 'Cancellata' },
    { value: ReleaseStatusEnum.RECEDUTA, label: 'Receduta' },
    { value: ReleaseStatusEnum.RINUNCIATA, label: 'Rinunciata' },
    { value: ReleaseStatusEnum.RETTIFICATA, label: 'Rettificata' },
]

export const NotificationTypeOptions: OptionType[] = [
    { value: NotificationTypeEnum.PRIMA_NOTIFICA, label: 'Prima Notifica' },
    { value: NotificationTypeEnum.NOTIFICA_VARIAZIONE, label: 'Notifica Variazione' },
    { value: NotificationTypeEnum.INFORMATIZZAZIONE_DI_NOTIFICA, label: 'Informatizzazione di Notifica' },
]

export const NotificationVariationOptions: OptionType[] = [
    { value: NotificationVariation.AUMENTO_O_DIMINUZIONE_DEL_NUMERO_DI_ATTIVITA, label: 'Aumento o Diminuzione del numero di attività' },
    { value: NotificationVariation.AUMENTO_O_DIMINUZIONE_DI_SUPERFICIE_CONDOTTA, label: 'Aumento o Diminuzione di superficie condotta' },
    { value: NotificationVariation.AUMENTO_O_DIMINUZIONE_DEL_NUMERO_DI_UP_ZOOTECNICHE, label: 'Aumento o Diminuzione del numero di up zootecniche' },
    { value: NotificationVariation.CAMBIO_ODC_DI_RIFERIMENTO, label: 'Cambio OdC di riferimento' },
]

export const NotificationExpirationTypeOptions: OptionType[] = [
    { value: ExpirationTypeEnum.CASO_A, label: 'Caso A' },
    { value: ExpirationTypeEnum.CASO_B, label: 'Caso B' },
    { value: ExpirationTypeEnum.CASO_C, label: 'Caso C' },
]

export const ParcelMethodOptions: OptionType[] = [
    { value: MethodEnum.BIOLOGICO, label: 'Biologico' },
    { value: MethodEnum.CONVENZIONALE, label: 'Convenzionale' },
    { value: MethodEnum.IN_CONVERSIONE, label: 'In Conversione' },
    { value: MethodEnum.NA, label: 'NA' }
]

export const FilieraOptions: OptionType[] = [
    { value: filierraNotContoTerzi.PRODOTTI_DELL_APICOLTURA, label: "Prodotti dell'Apicoltura" },
    { value: filierraNotContoTerzi.CIBI_PRONTI_OMOGENEIZZATI_E_DIETETICI, label: 'Cibi Pronti Omogeneizzati e Dietetici' },
    { value: filierraNotContoTerzi.BEVANDE_ESCLUSO_VINO, label: 'Bevande Escluso Vino' },
    { value: filierraNotContoTerzi.LIEVITO, label: 'Lievito' },
    { value: filierraNotContoTerzi.UOVA, label: 'Uova' },
    { value: filierraNotContoTerzi.VENDITA_AL_DETTAGLIO, label: 'Vendita al Dettaglio' },
    { value: filierraNotContoTerzi.FLOROVIVAISTICA, label: 'Florovivaistica' },
    { value: filierraNotContoTerzi.CEREALICOLA, label: 'Cerealicola' },
    { value: filierraNotContoTerzi.ORTICOLA, label: 'Orticola' },
    { value: filierraNotContoTerzi.VITIVINICOLA, label: 'Vitivinicola' },
    { value: filierraNotContoTerzi.MANGIMISTICA, label: 'Mangimistica' },
    { value: filierraNotContoTerzi.OLIVICOLA, label: 'Olivicola' },
    { value: filierraNotContoTerzi.FRUTTICOLA, label: 'Frutticola' },
    { value: filierraNotContoTerzi.CARNE_E_SALUMI, label: 'Carne e Salumi' },
    { value: filierraNotContoTerzi.PESCI_CROSTACEI_E_MOLLUSCHI, label: 'Pesci Crostacei e Molluschi' },
    { value: filierraNotContoTerzi.GRASSI_VEGETALI_E_ANIMALI, label: 'Grassi Vegetali e Animali' },
    { value: filierraNotContoTerzi.LATTE_E_DERIVATI, label: 'Latte e Derivati' },
    { value: filierraNotContoTerzi.MOLITURA_FORNO_E_FARINACEI, label: 'Molitura Forno e Farinacei' },
    { value: filierraNotContoTerzi.ZUCCHERO, label: 'Zucchero' },
    { value: filierraNotContoTerzi.CACAO, label: 'Cacao' },
    { value: filierraNotContoTerzi.TE, label: 'Te' },
    { value: filierraNotContoTerzi.CAFFE, label: 'Caffe' },
    { value: filierraNotContoTerzi.CONDIMENTI_E_SPEZIE, label: 'Condimenti e Spezie' }
];

export const ProcessingActivityOptions: OptionType[] = [
    { value: ProcessingActivityEnum.CONFEZIONAMENTO, label: 'Confezionamento' },
    { value: ProcessingActivityEnum.TRASFORMAZIONE, label: 'Trasformazione' },
    { value: ProcessingActivityEnum.MAGAZZINAGGIO, label: 'Magazzinaggio' },
    { value: ProcessingActivityEnum.FRIGOCONSERVAZIONE, label: 'Frigoconservazione' },
    { value: ProcessingActivityEnum.ETICHETTATURA, label: 'Etichettatura' },
    { value: ProcessingActivityEnum.COMMERCIALIZZAZIONE, label: 'Commercializzazione' }
];

export const ProcessingMethodTypeOptions: OptionType[] = [
    { value: ProcessingMethodType.BIOLOGICA, label: 'Biologica' },
    { value: ProcessingMethodType.PROMISCUO, label: 'Promiscuo' }
];


/* GG NOTIFICATION */

export const GGNotificationTypeOptions: OptionType[] = [
    { value: GGNotificationTypeEnum.ALTRO, label: 'Altro' },
    { value: GGNotificationTypeEnum.RICONFERMA_ANNUALE, label: 'Riconferma annuale' },
    { value: GGNotificationTypeEnum.ESTENSIONE, label: 'Estensione' },
    { value: GGNotificationTypeEnum.MODIFICA_DATI_ANAGRAFICI, label: 'Modifica Dati Anagrafici' },
    { value: GGNotificationTypeEnum.INIZIALE, label: 'Iniziale' },
]

export const GGStandardOptions: OptionType[] = [
    { value: GGStandardEnum.CoC, label: 'CoC' },
    { value: GGStandardEnum.IFA, label: 'IFA' },
]

export const GGStandardSubfieldOptions: OptionType[] = [
    { value: StandardSubfieldEnum.NESSUNO, label: 'Nessuno' },
    { value: StandardSubfieldEnum.FV, label: 'FV' },
    { value: StandardSubfieldEnum.FO, label: 'FO' },
]

export const GGStandardOptionOptions: OptionType[] = [
    { value: StandardOptionEnum.IFA_OPZIONE_1_PRODUTTORE_SITO_SINGOLO, label: 'IFA - Opzione 1 - Produttore Sito Singolo' },
    { value: StandardOptionEnum.IFA_OPZIONE_1_PRODUTTORE_MULTISITO_SENZA_SGQ, label: 'IFA - Opzione 1 - Produttore Multisito senza SGQ' },
    { value: StandardOptionEnum.IFA_OPZIONE_1_PRODUTTORE_MULTISITO_CON_SGQ, label: 'IFA - Opzione 1 - Produttore Multisito con SGQ' },
    { value: StandardOptionEnum.IFA_OPZIONE_2_CERTIFICAZIONE_DI_GRUPPO, label: 'IFA - Opzione 2 - Certificazione di gruppo' },
    { value: StandardOptionEnum.COC_OPZIONE_1_CERTIFICAZIONE_INDIVIDUALE, label: 'IFA - Opzione 1 - Certificazione individuale' },
    { value: StandardOptionEnum.COC_OPZIONE_1_SITI_SINGOLI, label: 'IFA - Opzione 1 - Siti Singoli' },
    { value: StandardOptionEnum.COC_OPZIONE_1_MULTISITO, label: 'IFA - Opzione 1 - Multisito' },
    { value: StandardOptionEnum.COC_OPZIONE_1_MULTISITO_PER_NEGOZI_AL_DETTAGLIO_E_CATENE_DI_RISTORANTI_IN_FRANCHISING, label: 'IFA - Opzione 1 - Multisito per negozi al dettaglio e catene di ristoranti in franchising' },
]

export const GGValutationResultOptions: OptionType[] = [
    { value: ValutationResultEnum.PRATICA_COMPLETATA, label: 'Pratica Completata' },
    { value: ValutationResultEnum.PRATICA_NON_COMPLETA, label: 'Pratica Non Completa' },
]

export const GGCropTypeOptions: OptionType[] = [
    { value: CropTypeEnum.PROTETTA, label: 'Protetta' },
    { value: CropTypeEnum.PIENO_CAMPO, label: 'Pieno campo' }
]

export const GGHarvestingTypeOptions: OptionType[] = [
    { value: HarvestingTypeEnum.PRIMA, label: 'Prima' },
    { value: HarvestingTypeEnum.SECONDA, label: 'Seconda' }
]

export const GGManipulationOptions: OptionType[] = [
    { value: GGManipulationEnum.CAMPO, label: 'Campo' },
    { value: GGManipulationEnum.MAGAZZINO, label: 'Magazzino' },
    { value: GGManipulationEnum.CAMPO_E_MAGAZZINO, label: 'Campo e Magazzino' },
    { value: GGManipulationEnum.NESSUNA, label: 'Nessuna' },
]

export const ProdIntegrataNotType: OptionType[] = [
    { value: NotProdIntegrataEnum.DOMANDA_INIZIALE, label: 'Domanda Iniziale' },
    { value: NotProdIntegrataEnum.CONFERMA, label: 'Conferma' },
    { value: NotProdIntegrataEnum.RETTIFICA, label: 'Rettifica' },
]

export const ProdIntegrataNotScopo: OptionType[] = [
    { value: NotProdIntegrataScopoEnum.ACA, label: 'Conformità Agro Climatico Ambientale (ACA)' },
    { value: NotProdIntegrataScopoEnum.MARCHIO_SQNPI, label: 'Marchio SQNPI' },
    { value: NotProdIntegrataScopoEnum.MARCHIO_SQNPI_E_ACA, label: 'Marchio SQNPI e Conformità agro climatica ambientale' },
]

/* ASSIGNMENT */

export const AssignmentStateOptions: OptionType[] = [
    { value: AssignmentStateEnum.COMPLETATO, label: 'Completato' },
    { value: AssignmentStateEnum.IN_ESECUZIONE, label: 'In esecuzione' },
    { value: AssignmentStateEnum.IN_LAVORAZIONE, label: 'In lavorazione' },
    { value: AssignmentStateEnum.REVOCATO, label: 'Revocato' },
]

/* INSPECTION VISIT */

export const IVAuditedActivityOptions: OptionType[] = [
    { value: IVAuditedActivityEnum.AGRICOLTURA_BIOLOGICA, label: 'Agricoltura Biologica' },
    { value: IVAuditedActivityEnum.BIO_SUISSE, label: 'Bio Suisse' },
    { value: IVAuditedActivityEnum.DEMETER, label: 'Demeter' },
]

export const IVActivityOptions: OptionType[] = [
    { value: IVActivityEnum.A_PRODUTTORE_ESCLUSIVO, label: 'A - Produttore Esclusivo' },
    { value: IVActivityEnum.AB_PRODUTTORE_PREPARATORE, label: 'AB - Produttore Preparatore' },
    { value: IVActivityEnum.ABC_PRODUTTORE_PREPARATORE_IMPORTATORE, label: 'ABC - Produttore Preparatore Importatore' },
    { value: IVActivityEnum.AC_PRODUTTORE_IMPORTATORE, label: 'AC - Produttore Importatore' },
    { value: IVActivityEnum.B_PREPARATORE_ESCLUSIVO, label: 'B - Preparatore Esclusivo' },
    { value: IVActivityEnum.BC_PREPARATORE_IMPORTATORE, label: 'BC - Preparatore Importatore' },
    { value: IVActivityEnum.C_IMPORTATORE_ESCLUSIVO, label: 'C - Importatore Esclusivo' },
    { value: IVActivityEnum.DIS_DISTRIBUZIONE_IMMISSIONE_SUL_MERCATO, label: 'DIS - Distribuzione immissione sul mercato' },
    { value: IVActivityEnum.E_ESPORTATORE, label: 'E - Esportatore' },
    { value: IVActivityEnum.GO_GRUPPO_DI_OPERATORI, label: 'GO - Gruppo di Operatori' },
    { value: IVActivityEnum.M_MANGIMI, label: 'M - Mangimi' },
    { value: IVActivityEnum.MAG_MAGAZZINAGGIO, label: 'MAG - Magazzinaggio' },
    { value: IVActivityEnum.V_VITIVINICOLO, label: 'V - Vitinicolo' },
]

export const IVActivityTypeOptions: OptionType[] = [
    { value: IVActivityTypeEnum.VEGETALE, label: 'Vegetale' },
    { value: IVActivityTypeEnum.ZOOTECNIA, label: 'Zootecnia' },
    { value: IVActivityTypeEnum.ACQUACOLTURA, label: 'Acquacoltura' },
    { value: IVActivityTypeEnum.VITIVINICOLO, label: 'Vitivinicolo' },
    { value: IVActivityTypeEnum.SEMENTIERO, label: 'Sementiero' },
    { value: IVActivityTypeEnum.MANGIMI, label: 'Mangimi' },
    { value: IVActivityTypeEnum.PUNTO_VENDITA_GDO, label: 'Punto Vendita GDO' },
]

export const IVTypeOptions: OptionType[] = [
    { value: InspectionVisitTypeEnum.ANNUNCIATA, label: 'Annunciata' },
    { value: InspectionVisitTypeEnum.NON_ANNUNCIATA, label: 'Non annunciata' },
    { value: InspectionVisitTypeEnum.FASE_DI_AVVIO, label: 'Fase di avvio' },
    { value: InspectionVisitTypeEnum.BIO_FASE_DI_AVVIO_CONTROLLO_IN_INGRESSO, label: 'Controllo in ingresso fase di avvio' },
    { value: InspectionVisitTypeEnum.BIO_CONTROLLO_ORDINARIO_ANNUALE, label: 'Controllo ordinario annuale' },
    { value: InspectionVisitTypeEnum.BIO_CONTROLLO_SUPPLEMENTARE_A_CAMPIONE, label: 'Controllo supplementare a campione' },
    { value: InspectionVisitTypeEnum.BIO_CONTROLLO_STRAORDINARIO_MIRATA, label: 'Controllo straordinario/mirata' },
    { value: InspectionVisitTypeEnum.SQNPI_INGRESSO, label: 'Controllo in ingresso SQNPI' },
    { value: InspectionVisitTypeEnum.SQNPI_ORDINARIA, label: 'Controllo ordinario SQNPI' },
    { value: InspectionVisitTypeEnum.SQNPI_STRAORDINARIA, label: 'Controllo straordinario SQNPI' },
    { value: InspectionVisitTypeEnum.DETERGENZA_INGRESSO, label: 'Controllo in ingresso Detergenza' },
    { value: InspectionVisitTypeEnum.DETERGENZA_ORDINARIA, label: 'Controllo ordinario Detergenza' },
    { value: InspectionVisitTypeEnum.DETERGENZA_STRAORDINARIA, label: 'Controllo straordinario Detergenza' },
    { value: InspectionVisitTypeEnum.QS_INGRESSO, label: 'Controllo in ingresso QS' },
    { value: InspectionVisitTypeEnum.QS_ORDINARIA, label: 'Controllo ordinario QS' },
    { value: InspectionVisitTypeEnum.QS_STRAORDINARIA, label: 'Controllo straordinario QS' },
    { value: InspectionVisitTypeEnum.GGAP_PRE_AUDIT, label: 'Pre-audit GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_AUDIT_INIZIALE_DI_CERTIFICAZIONE, label: 'Audit iniziale di certificazione GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_ESTENSIONE_PRODOTTI, label: 'Estensione prodotti GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_RINNOVO, label: 'Rinnovo GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_RI_CERTIFICAZIONE, label: 'Ri-certificazione GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_STRAORDINARIA, label: 'Controllo straordinario GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_ESTENSIONE_AZIENDE_AGRICOLE, label: 'Estensione aziende agricole GGAP' },
    { value: InspectionVisitTypeEnum.BIO_CONTROLLO_AGGIUNTIVO, label: 'Controllo aggiuntivo Bio' },
    { value: InspectionVisitTypeEnum.RZ_INGRESSO, label: 'Controllo in ingresso RZ' },
    { value: InspectionVisitTypeEnum.RZ_ORDINARIA, label: 'Controllo ordinario RZ' },
    { value: InspectionVisitTypeEnum.RZ_STRAORDINARIA, label: 'Controllo straordinario RZ' },
    { value: InspectionVisitTypeEnum.NF_INGRESSO, label: 'Controllo in ingresso NF' },
    { value: InspectionVisitTypeEnum.NF_ORDINARIA, label: 'Controllo ordinario NF' },
    { value: InspectionVisitTypeEnum.NF_STRAORDINARIA, label: 'Controllo straordinario NF' },
];

export const IVBioTypeOptions: OptionType[] = [
    { value: InspectionVisitTypeEnum.BIO_FASE_DI_AVVIO_CONTROLLO_IN_INGRESSO, label: 'Controllo in ingresso fase di avvio' },
    { value: InspectionVisitTypeEnum.BIO_CONTROLLO_ORDINARIO_ANNUALE, label: 'Controllo ordinario annuale' },
    { value: InspectionVisitTypeEnum.BIO_CONTROLLO_SUPPLEMENTARE_A_CAMPIONE, label: 'Controllo supplementare a campione' },
    { value: InspectionVisitTypeEnum.BIO_CONTROLLO_STRAORDINARIO_MIRATA, label: 'Controllo straordinario/mirata' },
    { value: InspectionVisitTypeEnum.BIO_CONTROLLO_AGGIUNTIVO, label: 'Controllo aggiuntivo Bio' },
]

export const IVSQNPITypeOptions: OptionType[] = [
    { value: InspectionVisitTypeEnum.SQNPI_INGRESSO, label: 'Controllo in ingresso SQNPI' },
    { value: InspectionVisitTypeEnum.SQNPI_ORDINARIA, label: 'Controllo ordinario SQNPI' },
    { value: InspectionVisitTypeEnum.SQNPI_STRAORDINARIA, label: 'Controllo straordinario SQNPI' },
]

export const IVDetergenzaTypeOptions: OptionType[] = [
    { value: InspectionVisitTypeEnum.DETERGENZA_INGRESSO, label: 'Controllo in ingresso Detergenza' },
    { value: InspectionVisitTypeEnum.DETERGENZA_ORDINARIA, label: 'Controllo ordinario Detergenza' },
    { value: InspectionVisitTypeEnum.DETERGENZA_STRAORDINARIA, label: 'Controllo straordinario Detergenza' },
]

export const IVQSTypeOptions: OptionType[] = [
    { value: InspectionVisitTypeEnum.QS_INGRESSO, label: 'Controllo in ingresso QS' },
    { value: InspectionVisitTypeEnum.QS_ORDINARIA, label: 'Controllo ordinario QS' },
    { value: InspectionVisitTypeEnum.QS_STRAORDINARIA, label: 'Controllo straordinario QS' },
]

export const IVGGAPTypeOptions: OptionType[] = [
    { value: InspectionVisitTypeEnum.GGAP_PRE_AUDIT, label: 'Pre-audit GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_AUDIT_INIZIALE_DI_CERTIFICAZIONE, label: 'Audit iniziale di certificazione GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_ESTENSIONE_PRODOTTI, label: 'Estensione prodotti GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_RINNOVO, label: 'Rinnovo GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_RI_CERTIFICAZIONE, label: 'Ri-certificazione GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_STRAORDINARIA, label: 'Controllo straordinario GGAP' },
    { value: InspectionVisitTypeEnum.GGAP_ESTENSIONE_AZIENDE_AGRICOLE, label: 'Estensione aziende agricole GGAP' },
]

export const IVRZTypeOptions: OptionType[] = [
    { value: InspectionVisitTypeEnum.RZ_INGRESSO, label: 'Controllo in ingresso RZ' },
    { value: InspectionVisitTypeEnum.RZ_ORDINARIA, label: 'Controllo ordinario RZ' },
    { value: InspectionVisitTypeEnum.RZ_STRAORDINARIA, label: 'Controllo straordinario RZ' },
]

export const IVNFTypeOptions: OptionType[] = [
    { value: InspectionVisitTypeEnum.NF_INGRESSO, label: 'Controllo in ingresso NF' },
    { value: InspectionVisitTypeEnum.NF_ORDINARIA, label: 'Controllo ordinario NF' },
    { value: InspectionVisitTypeEnum.NF_STRAORDINARIA, label: 'Controllo straordinario NF' },
]

export const IVModeOptions: OptionType[] = [
    { value: InspectionVisitModeEnum.ANNUNCIATA, label: 'Annunciata' },
    { value: InspectionVisitModeEnum.NON_ANNUNCIATA, label: 'Non annunciata' },
    { value: InspectionVisitModeEnum.CON_PREAVVISO, label: 'Con preavviso' },
    { value: InspectionVisitModeEnum.SENZA_PREAVVISO, label: 'Senza preavviso' },
]

export const IVControlResultOptions: OptionType[] = [
    { value: InspectionVisitControlResultEnum.CONFORME, label: 'Conforme' },
    { value: InspectionVisitControlResultEnum.NON_CONFORME, label: 'Non conforme' },
]

export const IVNonComplianceTypeOptions: OptionType[] = [
    { value: InspectionVisitNonComplianceTypeEnum.NESSUNA, label: 'Nessuna' },
    { value: InspectionVisitNonComplianceTypeEnum.SCARSA_ENTITA, label: 'Non conforme' },
    { value: InspectionVisitNonComplianceTypeEnum.GRAVE, label: 'Non conforme' },
    { value: InspectionVisitNonComplianceTypeEnum.CRITICA, label: 'Non conforme' },
]

/* SAMPLE COLLECTION */

export const SCEvaluationResultOptions: OptionType[] = [
    { value: EvaluationResultEnum.POSITIVO, label: 'Positivo' },
    { value: EvaluationResultEnum.NEGATIVO, label: 'Negativo' },
]

export const SCTestReportResultOptions: OptionType[] = [
    { value: TestReportResultEnum.CONFORME, label: 'Conforme' },
    { value: TestReportResultEnum.NON_CONFORME, label: 'Non Conforme' },
    { value: TestReportResultEnum.CONFORME_CON_PA_MINORE_LMR_3, label: 'Conforme con PA minore LMR 3' },
]

/* REIMBURSEMENT */

export const ReimbursementTypeOptions: OptionType[] = [
    { value: ReimbursementTypeEnum.ALLOGGIO, label: 'Alloggio' },
    { value: ReimbursementTypeEnum.INDENNITA_CHILOMETRICA, label: 'Indennità Chilometrica' },
    { value: ReimbursementTypeEnum.VITTO, label: 'Vitto' },
    { value: ReimbursementTypeEnum.PEDAGGIO, label: 'Pedaggio' },
    { value: ReimbursementTypeEnum.TRAGHETTO, label: 'Traghetto' },
    { value: ReimbursementTypeEnum.PARCHEGGIO, label: 'Parcheggio' },
    { value: ReimbursementTypeEnum.SERVIZI_POSTALI, label: 'Servizi Postali' },
    { value: ReimbursementTypeEnum.ALTRO, label: 'Altro' },
]

export const tipoAttivitaOptions: OptionType[] = [
    { value: IVActivityEnum.A_PRODUTTORE_ESCLUSIVO, label: 'A - Produttore Esclusivo' },
    { value: IVActivityEnum.AB_PRODUTTORE_PREPARATORE, label: 'AB - Produttore/Prepatore' },
    { value: IVActivityEnum.ABC_PRODUTTORE_PREPARATORE_IMPORTATORE, label: 'ABC - Produttore/Preparatore/Importatore' },
    { value: IVActivityEnum.AC_PRODUTTORE_IMPORTATORE, label: 'AC - Produttore/Importatore' },
    { value: IVActivityEnum.B_PREPARATORE_ESCLUSIVO, label: 'B - Preparatore Esclusivo' },
    { value: IVActivityEnum.BC_PREPARATORE_IMPORTATORE, label: 'BC - Preparatore/Importatore' },
    { value: IVActivityEnum.C_IMPORTATORE_ESCLUSIVO, label: 'C - Importatore Esclusiv' },
    { value: IVActivityEnum.DIS_DISTRIBUZIONE_IMMISSIONE_SUL_MERCATO, label: 'DIS - Distribuzione/Immissione sul mercato' },
    { value: IVActivityEnum.E_ESPORTATORE, label: 'E - Esportatore' },
    { value: IVActivityEnum.GO_GRUPPO_DI_OPERATORI, label: 'GO - Gruppo di Operatori' },
    { value: IVActivityEnum.M_MANGIMI, label: 'M - Mangimi' },
    { value: IVActivityEnum.MAG_MAGAZZINAGGIO, label: 'MAG - Magazzino' },
    { value: IVActivityEnum.V_VITIVINICOLO, label: 'V - Vitivinicolo' },
];

export const tipoAttivitaOptionsCodes: OptionType[] = [
    { value: IVActivityEnum.A_PRODUTTORE_ESCLUSIVO, label: 'A' },
    { value: IVActivityEnum.AB_PRODUTTORE_PREPARATORE, label: 'AB' },
    { value: IVActivityEnum.ABC_PRODUTTORE_PREPARATORE_IMPORTATORE, label: 'ABC' },
    { value: IVActivityEnum.AC_PRODUTTORE_IMPORTATORE, label: 'AC' },
    { value: IVActivityEnum.B_PREPARATORE_ESCLUSIVO, label: 'B' },
    { value: IVActivityEnum.BC_PREPARATORE_IMPORTATORE, label: 'BC' },
    { value: IVActivityEnum.C_IMPORTATORE_ESCLUSIVO, label: 'C' },
    { value: IVActivityEnum.DIS_DISTRIBUZIONE_IMMISSIONE_SUL_MERCATO, label: 'DIS' },
    { value: IVActivityEnum.E_ESPORTATORE, label: 'E' },
    { value: IVActivityEnum.GO_GRUPPO_DI_OPERATORI, label: 'GO' },
    { value: IVActivityEnum.M_MANGIMI, label: 'M' },
    { value: IVActivityEnum.MAG_MAGAZZINAGGIO, label: 'MAG' },
    { value: IVActivityEnum.V_VITIVINICOLO, label: 'V' },
];

export const IVActivityTypeOptionsCodes: OptionType[] = [
    { value: IVActivityTypeEnum.VEGETALE, label: 'v' },
    { value: IVActivityTypeEnum.ZOOTECNIA, label: 'z' },
    { value: IVActivityTypeEnum.ACQUACOLTURA, label: 'a' },
    { value: IVActivityTypeEnum.VITIVINICOLO, label: 'v' },
    { value: IVActivityTypeEnum.SEMENTIERO, label: 's' },
    { value: IVActivityTypeEnum.MANGIMI, label: 'm' },
    { value: IVActivityTypeEnum.PUNTO_VENDITA_GDO, label: 'gdo' },
]

export const PaymentTypeOptions: OptionType[] = [
    { value: PaymentTypeEnum.TRACCIATO, label: 'Tracciato' },
    { value: PaymentTypeEnum.NON_TRACCIATO, label: 'Non tracciato' },
]

export const UsedVehicleOptions: OptionType[] = [
    { value: UsedVehicleEnum.AEREO, label: 'Aereo' },
    { value: UsedVehicleEnum.TRENO, label: 'Treno' },
    { value: UsedVehicleEnum.BUS, label: 'Bus' },
    { value: UsedVehicleEnum.ALTRO, label: 'Altro' },
]

export const CarTypeOptions: OptionType[] = [
    { value: CarTypeEnum.AUTO_A_NOLEGGIO, label: 'Auto a noleggio' },
    { value: CarTypeEnum.AUTO_DI_PROPRIETA, label: 'Auto di proprietà' },
    { value: CarTypeEnum.AUTO_DELLA_SOCIETA, label: 'Auto della società' },
]

export const ProformaStatus: OptionType[] = [
    { value: ProformaStatusEnum.VALIDATA, label: 'Validata' },
    { value: ProformaStatusEnum.NON_VALIDATA, label: 'Non Validata' },
    { value: ProformaStatusEnum.DA_VALIDARE, label: 'Da Validare' },
]

/* RESULT CONTROL ACTIVITY */

export const ResultControlComplianceOptions: OptionType[] = [
    { value: ResultControlComplianceEnum.CONFORME, label: 'Conforme' },
    { value: ResultControlComplianceEnum.NON_CONFORME, label: 'Non conforme' },
    { value: ResultControlComplianceEnum.NON_APPLICABILE, label: 'Non applicabile' },
]

export function formatEuro(value: number | string | null | undefined): string {
    if (value == null) return "0.00";
    return parseFloat(value as string).toFixed(2);
}

export const TipoOperatoreDemeter: OptionType[] = [
    { value: 'SEMPLICE', label: 'Semplice' },
    { value: 'COMPLESSO', label: 'Complesso' }
]

export const EsitoBiosuisse: OptionType[] = [
    { value: 'CERTIFICAZIONE_EMESSA', label: 'Certificazione Emessa' },
    { value: 'CERTIFICAZIONE_NON_EMESSA', label: 'Certificazione Non Emessa' },
    { value: 'CERTIFICAZIONE_IN_CORSO', label: 'Certificazione In Corso' },
    { value: 'DOCUMENTAZIONE_NON_INVIATA', label: "Documentazione non inviata a biosuisse (Richiesta Integrazione inviata all'operatore)" },
    { value: 'CERTIFICAZIONE_ANNULLATA', label: 'Certificazione ' },
]

export const M024Type: OptionType[] = [
    { value: 'DOCUMENTO_CERTIFICAZIONE', label: 'Documento di certificazione' },
    { value: 'PROVVEDIMENTO', label: 'RE016 - Provvedimento' },
    { value: 'LIBERATORIA', label: 'Liberatoria' },
    { value: 'SOPPRESSIONE', label: "Soppressione Cautelativa" },
    { value: 'ALTRO', label: 'Altro ' },
]

export const StatoFatturaType: OptionType[] = [
    { value: 'TUTTE', label: 'Tutte' },
    { value: 'VALIDATE', label: 'Approvate' },
    { value: 'NON_VALIDATA', label: 'Non Approvate' },
    { value: 'DA_VALIDARE', label: 'Da Approvare' },
]

export const FilterInvoiceType: OptionType[] = [
    { value: 'TUTTE', label: 'Tutte' },
    { value: 'CON_FATTURA', label: 'Con Fattura' },
    { value: 'SENZA_FATTURA', label: 'Senza Fattura' },
]

export const ConformityOptions: OptionType[] = [
    { value: ConformityEnum.SI, label: 'Si' },
    { value: ConformityEnum.NO, label: 'No' },
    { value: ConformityEnum.NA, label: 'NA' }
]

export const ValTypeOptions: OptionType[] = [
    { value: ValTypeEnum.M24, label: 'M24' },
    { value: ValTypeEnum.VISITE, label: 'Visite' },
    { value: ValTypeEnum.VISITE_M24, label: 'Visite + M24' }
]


export const NotTypeOptions: OptionType[] = [
    { value: NotTypeEnum.PRIMA_NOTIFICA, label: 'Prima Notifica' },
    { value: NotTypeEnum.NOTIFICA_VARIAZIONE_ODC, label: "NOTIFICA DI VARIAZIONE - CAMBIO DELL'ODC DI RIFERIMENTO" },
    { value: NotTypeEnum.NOTIFICA_VARIAZIONE_ALTRO, label: 'NOTIFICA DI VARIAZIONE - ALTRO' },
    { value: NotTypeEnum.PRIMA_NOTIFICA_ODC, label: 'Prima notifica e cambio odc' },
]